import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, unref as _unref, vModelSelect as _vModelSelect, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "employee-page wage-hr-page" }
const _hoisted_2 = { class: "employee-layout" }
const _hoisted_3 = { class: "emp-sidebar member-remote-sidebar" }
const _hoisted_4 = { class: "sidebar-scroll" }
const _hoisted_5 = { class: "sidebar-top" }
const _hoisted_6 = { class: "sidebar-filter-card" }
const _hoisted_7 = { class: "filter-tabs" }
const _hoisted_8 = {
  key: 0,
  class: "sidebar-auto-collect"
}
const _hoisted_9 = { class: "sidebar-summary" }
const _hoisted_10 = { class: "summary-item" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = { class: "value highlight" }
const _hoisted_14 = { class: "summary-item" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "summary-item" }
const _hoisted_17 = { class: "summary-item" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "summary-item summary-item--sub" }
const _hoisted_20 = { class: "label-sub" }
const _hoisted_21 = { class: "sidebar-search-filters" }
const _hoisted_22 = { class: "search-input-wrapper" }
const _hoisted_23 = { class: "sidebar-filter-card" }
const _hoisted_24 = { class: "filter-tabs" }
const _hoisted_25 = {
  key: 0,
  class: "sidebar-auto-collect"
}
const _hoisted_26 = { class: "sidebar-summary" }
const _hoisted_27 = { class: "summary-item" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "summary-item" }
const _hoisted_30 = { class: "value highlight" }
const _hoisted_31 = { class: "summary-item" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "summary-item summary-item--sub" }
const _hoisted_34 = { class: "label-sub" }
const _hoisted_35 = { class: "sidebar-search-filters" }
const _hoisted_36 = { class: "search-input-wrapper" }
const _hoisted_37 = { class: "emp-main" }
const _hoisted_38 = { class: "wage-hr-toolbar" }
const _hoisted_39 = {
  class: "wage-hr-segment",
  role: "tablist",
  "aria-label": "인사관리 목록 구분"
}
const _hoisted_40 = ["aria-selected"]
const _hoisted_41 = { class: "segment-icon" }
const _hoisted_42 = { class: "segment-count" }
const _hoisted_43 = ["aria-selected"]
const _hoisted_44 = { class: "segment-icon" }
const _hoisted_45 = { class: "segment-count" }
const _hoisted_46 = { class: "wage-hr-toolbar-actions" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "wage-hr-tab-panel" }
const _hoisted_50 = { class: "wage-hr-tab-panel-body" }
const _hoisted_51 = { class: "hr-app-link-guide" }
const _hoisted_52 = {
  key: 0,
  class: "hr-ssn-guide"
}
const _hoisted_53 = { class: "hr-ssn-guide__body" }
const _hoisted_54 = { class: "hr-ssn-guide__title" }
const _hoisted_55 = {
  key: 0,
  class: "ben-quickadd-panel ben-quickadd-panel--employee"
}
const _hoisted_56 = { class: "quickadd-fields quickadd-fields--employee" }
const _hoisted_57 = { class: "qf-item qf-name" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = { class: "qf-item qf-birth" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["value", "onInput"]
const _hoisted_63 = { class: "qf-item qf-ssn" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = { class: "qf-item qf-job" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "qf-item qf-phone" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = { class: "qf-item qf-email" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = { class: "qf-item qf-date" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "qf-item qf-row-actions" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "qf-row-btns" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "quickadd-footer" }
const _hoisted_83 = { class: "quickadd-footer-hint" }
const _hoisted_84 = ["disabled", "title"]
const _hoisted_85 = { class: "emp-table-wrap" }
const _hoisted_86 = { class: "emp-table" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = {
  colspan: "11",
  class: "empty-row"
}
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  colspan: "11",
  class: "empty-row"
}
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "td-name" }
const _hoisted_93 = { class: "name-cell" }
const _hoisted_94 = { class: "name-with-app" }
const _hoisted_95 = ["title"]
const _hoisted_96 = {
  key: 0,
  class: "ssn-missing-badge",
  title: "상세에서 주민번호 뒷자리를 등록해 주세요"
}
const _hoisted_97 = {
  key: 1,
  class: "month-badge enter"
}
const _hoisted_98 = {
  key: 2,
  class: "month-badge enter"
}
const _hoisted_99 = {
  key: 3,
  class: "month-badge leave"
}
const _hoisted_100 = { class: "td-ssn" }
const _hoisted_101 = { class: "emp-ssn-line" }
const _hoisted_102 = ["title"]
const _hoisted_103 = { class: "emp-join" }
const _hoisted_104 = { class: "emp-join__main" }
const _hoisted_105 = { class: "col-schedule" }
const _hoisted_106 = ["disabled", "title", "onClick"]
const _hoisted_107 = { class: "wage-hr-tab-panel" }
const _hoisted_108 = { class: "wage-hr-tab-panel-body" }
const _hoisted_109 = {
  key: 0,
  class: "ben-quickadd-panel"
}
const _hoisted_110 = { class: "quickadd-fields" }
const _hoisted_111 = { class: "qf-item" }
const _hoisted_112 = { class: "qf-item" }
const _hoisted_113 = ["value"]
const _hoisted_114 = { class: "qf-item" }
const _hoisted_115 = { class: "qf-item" }
const _hoisted_116 = { class: "qf-item" }
const _hoisted_117 = { class: "qf-item" }
const _hoisted_118 = { class: "qf-item qf-grow" }
const _hoisted_119 = ["onKeydown"]
const _hoisted_120 = { class: "qf-item qf-action" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = { class: "emp-table-wrap" }
const _hoisted_123 = { class: "emp-table" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = {
  colspan: "9",
  class: "empty-row"
}
const _hoisted_126 = { key: 1 }
const _hoisted_127 = {
  colspan: "9",
  class: "empty-row"
}
const _hoisted_128 = ["onClick"]
const _hoisted_129 = { class: "td-name" }
const _hoisted_130 = { class: "name-cell" }
const _hoisted_131 = {
  key: 0,
  class: "month-badge enter"
}
const _hoisted_132 = {
  key: 1,
  class: "month-badge enter"
}
const _hoisted_133 = {
  key: 2,
  class: "month-badge leave"
}
const _hoisted_134 = { class: "td-ssn" }
const _hoisted_135 = { class: "emp-ssn-line" }
const _hoisted_136 = { class: "col-schedule" }
const _hoisted_137 = ["disabled", "title", "onClick"]
const _hoisted_138 = {
  key: 0,
  class: "hr-detail-modal"
}
const _hoisted_139 = { class: "hr-detail-modal__header" }
const _hoisted_140 = { class: "hr-detail-modal__profile" }
const _hoisted_141 = { class: "hr-detail-modal__title-wrap" }
const _hoisted_142 = { class: "hr-detail-modal__subtitle" }
const _hoisted_143 = { class: "hr-detail-modal__badges" }
const _hoisted_144 = ["title"]
const _hoisted_145 = {
  key: 1,
  class: "hr-detail-modal__chip hr-detail-modal__chip--enter"
}
const _hoisted_146 = {
  key: 2,
  class: "hr-detail-modal__chip hr-detail-modal__chip--leave"
}
const _hoisted_147 = { class: "hr-detail-modal__body" }
const _hoisted_148 = { class: "hr-detail-modal__form" }
const _hoisted_149 = { class: "hr-detail-modal__field" }
const _hoisted_150 = { class: "hr-detail-modal__field" }
const _hoisted_151 = ["value"]
const _hoisted_152 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_153 = { class: "hr-ssn-label" }
const _hoisted_154 = {
  key: 0,
  class: "hr-ssn-state hr-ssn-state--saved"
}
const _hoisted_155 = {
  key: 1,
  class: "hr-ssn-state hr-ssn-state--missing"
}
const _hoisted_156 = {
  key: 0,
  class: "hr-ssn-guide hr-ssn-guide--detail"
}
const _hoisted_157 = { class: "hr-ssn-row" }
const _hoisted_158 = { class: "hr-ssn-front" }
const _hoisted_159 = ["placeholder"]
const _hoisted_160 = ["disabled"]
const _hoisted_161 = {
  key: 1,
  class: "hr-ssn-hint hr-ssn-hint--saved"
}
const _hoisted_162 = {
  key: 2,
  class: "hr-ssn-hint"
}
const _hoisted_163 = { class: "hr-detail-modal__field" }
const _hoisted_164 = ["value"]
const _hoisted_165 = { class: "hr-detail-modal__field" }
const _hoisted_166 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_167 = {
  key: 0,
  class: "hr-detail-modal__field hr-detail-modal__field--full"
}
const _hoisted_168 = { class: "hr-employment-lines" }
const _hoisted_169 = { class: "hr-employment-line__src" }
const _hoisted_170 = { class: "hr-employment-line__date" }
const _hoisted_171 = { class: "hr-employment-line__end" }
const _hoisted_172 = { class: "hr-employment-note" }
const _hoisted_173 = { class: "hr-detail-modal__field" }
const _hoisted_174 = {
  key: 0,
  class: "hr-field-source"
}
const _hoisted_175 = { class: "hr-detail-modal__field" }
const _hoisted_176 = {
  key: 0,
  class: "hr-field-source"
}
const _hoisted_177 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_178 = { class: "hr-addr-row" }
const _hoisted_179 = ["value"]
const _hoisted_180 = ["value"]
const _hoisted_181 = {
  key: 1,
  class: "hr-detail-modal__section"
}
const _hoisted_182 = {
  key: 2,
  class: "hr-detail-modal__field hr-detail-modal__field--full"
}
const _hoisted_183 = ["value"]
const _hoisted_184 = { class: "hr-detail-modal__footer" }
const _hoisted_185 = {
  key: 0,
  class: "hr-detail-modal"
}
const _hoisted_186 = { class: "hr-detail-modal__header" }
const _hoisted_187 = { class: "hr-detail-modal__profile" }
const _hoisted_188 = { class: "hr-detail-modal__title-wrap" }
const _hoisted_189 = { class: "hr-detail-modal__subtitle" }
const _hoisted_190 = { class: "hr-detail-modal__badges" }
const _hoisted_191 = {
  key: 0,
  class: "hr-detail-modal__chip hr-detail-modal__chip--enter"
}
const _hoisted_192 = {
  key: 1,
  class: "hr-detail-modal__chip hr-detail-modal__chip--leave"
}
const _hoisted_193 = {
  key: 2,
  class: "hr-detail-modal__chip hr-detail-modal__chip--enter"
}
const _hoisted_194 = { class: "hr-detail-modal__tabs" }
const _hoisted_195 = { class: "hr-detail-modal__body" }
const _hoisted_196 = {
  key: 0,
  class: "hr-detail-modal__form"
}
const _hoisted_197 = {
  key: 0,
  class: "recipient-history-empty"
}
const _hoisted_198 = {
  key: 1,
  class: "recipient-history-empty"
}
const _hoisted_199 = {
  key: 2,
  class: "recipient-history-list"
}
const _hoisted_200 = {
  key: 1,
  class: "hr-detail-modal__form"
}
const _hoisted_201 = { class: "hr-detail-modal__field" }
const _hoisted_202 = { class: "hr-detail-modal__field" }
const _hoisted_203 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_204 = { class: "hr-ssn-label" }
const _hoisted_205 = {
  key: 0,
  class: "hr-ssn-state hr-ssn-state--saved"
}
const _hoisted_206 = {
  key: 1,
  class: "hr-ssn-state hr-ssn-state--missing"
}
const _hoisted_207 = { class: "hr-ssn-row" }
const _hoisted_208 = ["placeholder"]
const _hoisted_209 = ["disabled"]
const _hoisted_210 = {
  key: 0,
  class: "hr-ssn-hint hr-ssn-hint--saved"
}
const _hoisted_211 = {
  key: 1,
  class: "hr-ssn-hint"
}
const _hoisted_212 = { class: "hr-detail-modal__field" }
const _hoisted_213 = { class: "hr-detail-modal__field" }
const _hoisted_214 = { class: "hr-detail-modal__field" }
const _hoisted_215 = { class: "hr-detail-modal__field" }
const _hoisted_216 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_217 = { class: "hr-detail-modal__field" }
const _hoisted_218 = { class: "hr-detail-modal__field" }
const _hoisted_219 = {
  key: 0,
  class: "recipient-stay-action hr-detail-modal__field--full"
}
const _hoisted_220 = { class: "recipient-stay-action__row" }
const _hoisted_221 = ["disabled"]
const _hoisted_222 = {
  key: 1,
  class: "recipient-stay-action hr-detail-modal__field--full"
}
const _hoisted_223 = { class: "recipient-stay-action__row" }
const _hoisted_224 = ["disabled"]
const _hoisted_225 = { class: "hr-detail-modal__field hr-detail-modal__field--full" }
const _hoisted_226 = { class: "hr-addr-row" }
const _hoisted_227 = ["value"]
const _hoisted_228 = ["value"]
const _hoisted_229 = {
  key: 2,
  class: "hr-detail-modal__section"
}
const _hoisted_230 = {
  key: 3,
  class: "hr-detail-modal__field hr-detail-modal__field--full"
}
const _hoisted_231 = ["value"]
const _hoisted_232 = { class: "hr-detail-modal__footer" }
const _hoisted_233 = { class: "hr-ben-excel-modal" }
const _hoisted_234 = { class: "hr-ben-excel-header" }
const _hoisted_235 = { class: "hr-ben-excel-body" }
const _hoisted_236 = ["disabled"]
const _hoisted_237 = { class: "hr-ben-excel-drop" }
const _hoisted_238 = { class: "hr-ben-excel-footer" }
const _hoisted_239 = ["disabled"]
const _hoisted_240 = ["disabled"]

import { ref, computed, onMounted, watch, inject, nextTick } from 'vue';
import { usePageTabNav } from '@/composables/usePageTabNav';
import type { Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { employeeApi, beneficiaryApi, homeScheduleApi } from '@/services/api';
import EmployeeProfileLinkPanel from '@/components/employee/EmployeeProfileLinkPanel.vue';
import { useJobTypes } from '@/composables/useJobTypes';
import { EMPLOYEE_POSITION_OPTIONS } from '@/constants/employeePositions';
import {
  findEmployeeDuplicate,
  getEmployeeRowIdentity,
  DUPLICATE_EMPLOYEE_MESSAGE,
} from '@/utils/employeeDuplicate';
import BeneficiaryCalendarModal from '@/components/member/schedule/BeneficiaryCalendarModal.vue';
import BeneficiaryAllScheduleModal from '@/components/member/schedule/BeneficiaryAllScheduleModal.vue';
import ScheduleCalendarModal from '@/components/member/schedule/ScheduleCalendarModal.vue';
import { downloadPdfBlob, getApiErrorMessage } from '@/utils/downloadPdf';
import LtcsRequestSidebarButton from '@/components/member/request/LtcsRequestSidebarButton.vue';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import DaumPostcodeDialog from '@/components/common/DaumPostcodeDialog.vue';
type HrTab = 'employee' | 'beneficiary';

interface CalendarBeneficiary {
  patient_code: string;
  patient_name: string;
}

interface CalendarCaregiver {
  emp_name: string;
  emp_birth: string;
  emp_job?: string;
}

type EmployeeQuickRow = {
  _key: number;
  clci_name: string;
  clci_birth_ymd: string;
  clci_birth_date: string;
  clci_ssn_back: string;
  clci_job_type: string;
  clci_work_start_date: string;
  clci_phone: string;
  clci_email: string;
};

type EmploymentLine = {
  clci_source?: string;
  clci_source_label?: string;
  clci_idx?: number;
  clci_work_start_date?: string | null;
  clci_work_end_date?: string | null;
  clci_wdate?: string | null;
  clci_rdate?: string | null;
  month_status?: string | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberWageHrManagement',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const memberData = inject<any>('memberData');
const selectedBizGubunRef = inject<Ref<string>>('selectedBizGubun');
const selectedBizGubun = computed(() => selectedBizGubunRef?.value || '');

const memberCode = computed(() => {
  return (route.params.memberCode as string) || memberData?.value?.m_code || '';
});

const activeTab = ref<HrTab>('employee');

const setActiveTab = (tab: HrTab) => {
  activeTab.value = tab;
  router.replace({ query: { ...route.query, tab } });
};

const hrPageTabs = computed(() => [
  { key: 'employee', title: '사원' },
  { key: 'beneficiary', title: '수급자' },
]);
usePageTabNav('wage-hr', hrPageTabs, activeTab, (key) => {
  if (key === 'employee' || key === 'beneficiary') setActiveTab(key);
});

/** 직종 선택 목록 — DB caion_job_type (관리자 직종관리) */
const { positionOptions, defaultPosition, isEmployeePosition, loadJobTypes: refreshJobTypes } = useJobTypes();

// 현원·퇴사, 일정표, 자료요청은 이번 달 기준. 화면에서 연월은 고르지 않는다.
const selectedYear = ref(new Date().getFullYear());
const selectedMonth = ref(new Date().getMonth() + 1);
const selectedYearMonth = computed(
  () => `${selectedYear.value}-${String(selectedMonth.value).padStart(2, '0')}`
);
const scheduleYearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

// ── 사원 (LTCS 자동수집 + 직접등록 UNION) ──
const employeeLoading = ref(false);
const employeeList = ref<any[]>([]);
const employeeStats = ref({
  total: 0,
  hyunwon: 0,
  toesaw: 0,
  monthEnter: 0,
  monthLeave: 0,
});
const employeeMeta = ref<{ lastAutoCollectWdate?: string | null; yearMonth?: string }>({});
const employeeStatusFilter = ref('');
const employeeSearchText = ref('');
const employeeSortKey = ref('clci_name');
const employeeSortOrder = ref<'asc' | 'desc'>('asc');
const employeeDetailDialog = ref(false);
const selectedEmployee = ref<any>(null);
const showEmployeeQuickAdd = ref(false);
const employeeSaving = ref(false);
const employeeDeleting = ref(false);
const ssnRevealing = ref(false);
const ssnRevealed = ref(false);
const ssnRevealedValue = ref('');
const employeeSsnEditing = ref(false);

let employeeQuickRowSeq = 1;
const createEmptyEmployeeRow = (): EmployeeQuickRow => ({
  _key: employeeQuickRowSeq++,
  clci_name: '',
  clci_birth_ymd: '',
  clci_birth_date: '',
  clci_ssn_back: '',
  clci_job_type: defaultPosition.value || (EMPLOYEE_POSITION_OPTIONS[0] as string),
  clci_work_start_date: '',
  clci_phone: '',
  clci_email: '',
});

const newEmployeeRows = ref<EmployeeQuickRow[]>([createEmptyEmployeeRow()]);

const addEmployeeQuickRow = () => {
  newEmployeeRows.value.push(createEmptyEmployeeRow());
};

const removeEmployeeQuickRow = (idx: number) => {
  if (newEmployeeRows.value.length <= 1) return;
  newEmployeeRows.value.splice(idx, 1);
};

const resetEmployeeQuickRows = () => {
  newEmployeeRows.value = [createEmptyEmployeeRow()];
};

const employeeEditForm = ref({
  clci_name: '',
  clci_birth_ymd: '',
  clci_birth_date: '',
  clci_ssn_back: '',
  clci_job_type: '',
  clci_work_start_date: '',
  clci_work_end_date: '',
  clci_phone: '',
  clci_email: '',
  clci_zipcode: '',
  clci_addr1: '',
  clci_addr2: '',
});

// ── 다음주소찾기 (사원/수급자 공용) ──
const postcodeDialog = ref(false);
const postcodeTarget = ref<'employee' | 'beneficiary'>('employee');

const openPostcode = (target: 'employee' | 'beneficiary') => {
  postcodeTarget.value = target;
  postcodeDialog.value = true;
};

const onPostcodeSelect = (data: { zonecode: string; address: string }) => {
  if (postcodeTarget.value === 'employee') {
    employeeEditForm.value.clci_zipcode = data.zonecode;
    employeeEditForm.value.clci_addr1 = data.address;
  } else {
    beneficiaryEditForm.value.clsr_zipcode = data.zonecode;
    beneficiaryEditForm.value.clsr_addr1 = data.address;
  }
};

const isValidSsnBack = (raw: string) => /^\d{7}$/.test(String(raw || '').replace(/\D/g, ''));

/** 생년월일 8자리(YYYYMMDD) → YYYY-MM-DD. 1900년부터 올해까지, 실제 있는 날짜만. */
const birthDateFromYmd8 = (raw: string): string => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!/^\d{8}$/.test(digits)) return '';
  const yyyy = Number(digits.slice(0, 4));
  const mm = Number(digits.slice(4, 6));
  const dd = Number(digits.slice(6, 8));
  const currentYear = new Date().getFullYear();
  if (yyyy < 1900 || yyyy > currentYear || mm < 1 || mm > 12 || dd < 1 || dd > 31) return '';
  const iso = `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
  const check = new Date(`${iso}T00:00:00`);
  if (check.getFullYear() !== yyyy || check.getMonth() + 1 !== mm || check.getDate() !== dd) return '';
  return iso;
};

const ymd8FromBirthDate = (birthDate: string): string => {
  const d = formatDate(birthDate);
  if (!d || d === '-') return '';
  const digits = d.replace(/\D/g, '');
  return digits.length === 8 ? digits : '';
};

const onEmployeeBirthYmdInput = (
  target: { clci_birth_ymd: string; clci_birth_date: string },
  event: Event
) => {
  const el = event.target as HTMLInputElement;
  const digits = String(el.value || '').replace(/\D/g, '').slice(0, 8);
  target.clci_birth_ymd = digits;
  target.clci_birth_date = birthDateFromYmd8(digits);
  if (el.value !== digits) el.value = digits;
};

const employeeQuickAddJoinReady = computed(() =>
  newEmployeeRows.value.every((row) => !!row.clci_work_start_date)
);

/** 주민번호 뒷자리 미등록 여부 (API: clci_has_ssn_back) */
const isEmployeeSsnMissing = (row: any): boolean => !row?.clci_has_ssn_back;

const employeeSsnMissingCount = computed(
  () => employeeList.value.filter((r) => isEmployeeSsnMissing(r)).length
);

const isEmployeeAppLinked = (row: any): boolean =>
  row?.app_linked === true || row?.app_linked === 1 || row?.app_linked === 'Y';

const employeeAppLinkedCount = computed(
  () => employeeList.value.filter((r) => isEmployeeAppLinked(r)).length
);

const employeeAppLinkTitle = (row: any): string => {
  const label = String(row?.app_link_label || '').trim();
  return label ? `카이온 앱 연동 · ${label}` : '카이온 앱 연동';
};

const getEmployeeRowMissingFields = (f: EmployeeQuickRow): string[] => {
  const missing: string[] = [];
  if (!f.clci_name.trim()) missing.push('성명');
  if (!birthDateFromYmd8(f.clci_birth_ymd)) missing.push('생년월일(8자리)');
  if (!isValidSsnBack(f.clci_ssn_back)) missing.push('주민번호 뒷자리(7자리)');
  if (!f.clci_job_type) missing.push('직종');
  if (!f.clci_phone.trim()) missing.push('휴대폰');
  if (!f.clci_work_start_date) missing.push('입사일');
  return missing;
};

const formatSsnFront = (birthDate: string) => {
  const d = formatDate(birthDate);
  if (!d || d === '-') return '******';
  const yymmdd = d.replace(/-/g, '').slice(2);
  return yymmdd.length === 6 ? yymmdd : '******';
};

const beneficiarySsnFront = (item: { clsr_ssn_front?: string | null; clsr_birth_date?: string | null }) => {
  const stored = String(item?.clsr_ssn_front || '').replace(/\D/g, '');
  if (stored.length === 6) return stored;
  return formatSsnFront(item?.clsr_birth_date || '');
};

const isBeneficiarySsnMissing = (item: { clsr_has_ssn_back?: boolean }) => !item?.clsr_has_ssn_back;

const saveNewEmployee = async () => {
  if (employeeSaving.value) return;

  // 날짜 입력 중(한 자리 월·일)이면 blur로 패딩·modelValue 반영
  const active = document.activeElement as HTMLElement | null;
  if (active && typeof active.blur === 'function') active.blur();
  await nextTick();

  if (!memberCode.value) {
    alert('시설 정보를 확인할 수 없습니다. 페이지를 새로고침한 뒤 다시 시도해 주세요.');
    return;
  }

  const rows = newEmployeeRows.value;
  const issues: string[] = [];
  for (let i = 0; i < rows.length; i++) {
    const missing = getEmployeeRowMissingFields(rows[i]);
    if (missing.length) {
      issues.push(`${i + 1}행: ${missing.join(', ')}`);
    }
  }
  if (issues.length) {
    alert(`다음 항목을 입력해 주세요.\n· ${issues.join('\n· ')}`);
    return;
  }

  // 배치 내 중복 체크
  const seenKeys = new Set<string>();
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const key = `${r.clci_name.trim()}|${r.clci_birth_date}|${r.clci_work_start_date}`;
    if (seenKeys.has(key)) {
      alert(`${i + 1}행: 입력 목록에 동일한 사원(성명·생년월일·입사일)이 있습니다.`);
      return;
    }
    seenKeys.add(key);
  }

  // 기존 목록 중복 체크
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const dup = findEmployeeDuplicate(employeeList.value, {
      clci_name: r.clci_name.trim(),
      clci_birth_date: r.clci_birth_date,
      clci_work_start_date: r.clci_work_start_date,
    });
    if (dup) {
      alert(`${i + 1}행: ${DUPLICATE_EMPLOYEE_MESSAGE}`);
      return;
    }
  }

  employeeSaving.value = true;
  let successCount = 0;
  try {
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const ssnDigits = r.clci_ssn_back.replace(/\D/g, '');
      const email = r.clci_email.trim();
      try {
        await employeeApi.create(memberCode.value, {
          clci_name: r.clci_name.trim(),
          clci_birth_date: r.clci_birth_date,
          clci_ssn_back: ssnDigits,
          clci_job_type: r.clci_job_type,
          clci_work_start_date: r.clci_work_start_date,
          clci_phone: r.clci_phone.trim(),
          ...(email ? { clci_email: email } : {}),
        });
        successCount += 1;
      } catch (error: any) {
        const message = error.response?.data?.message || error.message || '등록에 실패했습니다.';
        const remain = rows.length - i;
        alert(
          `${i + 1}행(${r.clci_name.trim() || '이름없음'}) 등록 실패: ${message}` +
            `${error.response?.status ? ` (${error.response.status})` : ''}` +
            (successCount ? `\n\n이미 ${successCount}명은 등록되었습니다.` : '') +
            (remain > 1 ? `\n남은 ${remain - 1}명은 등록되지 않았습니다.` : '')
        );
        await loadEmployeeList();
        // 실패한 행부터 남김
        newEmployeeRows.value = rows.slice(i).map((row) => ({ ...row, _key: employeeQuickRowSeq++ }));
        return;
      }
    }
    resetEmployeeQuickRows();
    showEmployeeQuickAdd.value = false;
    await loadEmployeeList();
    if (successCount > 1) {
      alert(`${successCount}명 등록이 완료되었습니다.`);
    }
  } finally {
    employeeSaving.value = false;
  }
};

const filteredEmployeeList = computed(() => {
  let result = [...employeeList.value];
  if (employeeStatusFilter.value === '현원') {
    result = result.filter((r) => r.month_status === '현원');
  } else if (employeeStatusFilter.value === '퇴사') {
    result = result.filter((r) => r.month_status === '퇴사');
  } else if (employeeStatusFilter.value === '주민번호미등록') {
    result = result.filter((r) => isEmployeeSsnMissing(r));
  } else if (employeeStatusFilter.value === '앱연동') {
    result = result.filter((r) => isEmployeeAppLinked(r));
  }
  if (employeeSearchText.value) {
    const keyword = employeeSearchText.value.toLowerCase();
    result = result.filter(
      (r) =>
        r.clci_name?.toLowerCase().includes(keyword) ||
        r.clci_job_type?.toLowerCase().includes(keyword)
    );
  }

  const sortKey = employeeSortKey.value;
  const sortOrder = employeeSortOrder.value;
  result.sort((a, b) => {
    if (a.is_duplicate !== b.is_duplicate) {
      return a.is_duplicate ? -1 : 1;
    }
    if (!sortKey) return 0;
    if (sortKey === 'app_linked') {
      const rank = (row: any) => (isEmployeeAppLinked(row) ? 1 : 0);
      const diff = rank(a) - rank(b);
      if (diff !== 0) return sortOrder === 'asc' ? diff : -diff;
      const aLabel = String(a.app_link_label || '');
      const bLabel = String(b.app_link_label || '');
      if (aLabel === bLabel) return 0;
      const cmp = aLabel.localeCompare(bLabel, 'ko');
      return sortOrder === 'asc' ? cmp : -cmp;
    }
    let aVal: string | number = a[sortKey];
    let bVal: string | number = b[sortKey];
    if (aVal == null) aVal = '';
    if (bVal == null) bVal = '';
    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();
    if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  return result;
});

const toggleEmployeeSort = (key: string) => {
  if (employeeSortKey.value === key) {
    employeeSortOrder.value = employeeSortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    employeeSortKey.value = key;
    employeeSortOrder.value = 'asc';
  }
};

const getEmployeeSortIcon = (key: string) => {
  if (employeeSortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return employeeSortOrder.value === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down';
};

const loadEmployeeList = async () => {
  if (!memberCode.value) return;
  employeeLoading.value = true;
  try {
    const res = await employeeApi.getList(memberCode.value, {
      yearMonth: selectedYearMonth.value,
      groupSamePerson: true,
      limit: 2000,
    });
    const data = res.data?.data;
    employeeList.value = data?.list || [];
    if (data?.stats) {
      employeeStats.value = {
        total: data.stats.total ?? 0,
        hyunwon: data.stats.hyunwon ?? 0,
        toesaw: data.stats.toesaw ?? 0,
        monthEnter: data.stats.monthEnter ?? 0,
        monthLeave: data.stats.monthLeave ?? 0,
      };
    }
    if (data?.meta) {
      employeeMeta.value = {
        lastAutoCollectWdate: data.meta.lastAutoCollectWdate ?? null,
        yearMonth: data.meta.yearMonth,
      };
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`사원 목록 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
    employeeList.value = [];
  } finally {
    employeeLoading.value = false;
  }
};

const startEmployeeSsnEdit = () => {
  employeeSsnEditing.value = true;
  ssnRevealed.value = false;
  employeeEditForm.value.clci_ssn_back = '';
};

const cancelEmployeeSsnEdit = () => {
  employeeSsnEditing.value = false;
  employeeEditForm.value.clci_ssn_back = '';
};

const openEmployeeDetail = (item: any) => {
  selectedEmployee.value = item;
  ssnRevealed.value = false;
  ssnRevealedValue.value = '';
  employeeSsnEditing.value = false;
  const birth = formatDate(item.clci_birth_date) === '-' ? '' : formatDate(item.clci_birth_date);
  employeeEditForm.value = {
    clci_name: item.clci_name || '',
    clci_birth_ymd: ymd8FromBirthDate(birth),
    clci_birth_date: birth,
    clci_ssn_back: '',
    clci_job_type: item.clci_job_type || '',
    clci_work_start_date: formatDate(item.clci_work_start_date) === '-' ? '' : formatDate(item.clci_work_start_date),
    clci_work_end_date: formatDate(item.clci_work_end_date) === '-' ? '' : formatDate(item.clci_work_end_date),
    clci_phone: item.clci_phone || '',
    clci_email: item.clci_email || '',
    clci_zipcode: item.clci_zipcode || '',
    clci_addr1: item.clci_addr1 || '',
    clci_addr2: item.clci_addr2 || '',
  };
  employeeDetailDialog.value = true;
};

const closeEmployeeDetail = () => {
  employeeDetailDialog.value = false;
  selectedEmployee.value = null;
  ssnRevealed.value = false;
  ssnRevealedValue.value = '';
  employeeSsnEditing.value = false;
};

/** 앱 회원정보와 맞춘 뒤 상세 폼의 같은 항목을 서버 값으로 다시 채운다 */
const onEmployeeProfileLinked = async () => {
  const current = selectedEmployee.value;
  if (!current?.clci_idx) return;
  const source = current.clci_source === 'manual' ? 'manual' : 'auto';
  try {
    const res = await employeeApi.getById(
      memberCode.value,
      source,
      current.clci_idx,
      selectedYearMonth.value
    );
    const row = res.data?.data;
    if (!row || !employeeDetailDialog.value) return;
    const birth = formatDate(row.clci_birth_date) === '-' ? '' : formatDate(row.clci_birth_date);
    employeeEditForm.value.clci_name = row.clci_name || '';
    employeeEditForm.value.clci_birth_ymd = ymd8FromBirthDate(birth);
    employeeEditForm.value.clci_birth_date = birth;
    employeeEditForm.value.clci_phone = row.clci_phone || '';
    employeeEditForm.value.clci_email = row.clci_email || '';
    employeeEditForm.value.clci_zipcode = row.clci_zipcode || '';
    employeeEditForm.value.clci_addr1 = row.clci_addr1 || '';
    employeeEditForm.value.clci_addr2 = row.clci_addr2 || '';
    selectedEmployee.value = { ...current, ...row, clci_source: source };
    await loadEmployeeList();
  } catch {
    /* 목록을 다시 열면 반영된다 */
  }
};

const revealEmployeeSsn = async () => {
  if (!selectedEmployee.value || !memberCode.value || ssnRevealing.value) return;

  if (ssnRevealed.value) {
    ssnRevealed.value = false;
    ssnRevealedValue.value = '';
    return;
  }

  const source = selectedEmployee.value.clci_source === 'manual' ? 'manual' : 'auto';
  ssnRevealing.value = true;
  try {
    const res = await employeeApi.revealSsn(memberCode.value, source, selectedEmployee.value.clci_idx);
    const plain = res.data?.data?.clci_ssn_back;
    if (!plain) {
      alert('저장된 주민번호 뒷자리가 없습니다.');
      return;
    }
    ssnRevealedValue.value = plain;
    ssnRevealed.value = true;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '조회에 실패했습니다.';
    alert(`주민번호 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    ssnRevealing.value = false;
  }
};

const saveEmployeeEdit = async () => {
  if (!selectedEmployee.value || employeeSaving.value || !memberCode.value) return;

  const birthDate = birthDateFromYmd8(employeeEditForm.value.clci_birth_ymd);
  if (!birthDate) {
    alert('생년월일은 숫자 8자리(YYYYMMDD)여야 합니다.');
    return;
  }
  employeeEditForm.value.clci_birth_date = birthDate;

  if (!employeeEditForm.value.clci_work_start_date) {
    alert('입사일을 입력해 주세요.');
    return;
  }

  const ssnInput = employeeEditForm.value.clci_ssn_back.replace(/\D/g, '');
  if (ssnInput && !isValidSsnBack(ssnInput)) {
    alert('주민번호 뒷자리는 숫자 7자리여야 합니다.');
    return;
  }

  const excludeId = getEmployeeRowIdentity(selectedEmployee.value);
  const dup = findEmployeeDuplicate(
    employeeList.value,
    {
      clci_name: employeeEditForm.value.clci_name.trim(),
      clci_birth_date: employeeEditForm.value.clci_birth_date,
      clci_work_start_date: employeeEditForm.value.clci_work_start_date,
    },
    excludeId
  );
  if (dup) {
    alert(DUPLICATE_EMPLOYEE_MESSAGE);
    return;
  }

  const source = selectedEmployee.value.clci_source === 'manual' ? 'manual' : 'auto';
  const payload: Record<string, unknown> = {
    clci_name: employeeEditForm.value.clci_name.trim(),
    clci_birth_date: employeeEditForm.value.clci_birth_date,
    clci_job_type: employeeEditForm.value.clci_job_type || null,
    clci_work_start_date: employeeEditForm.value.clci_work_start_date,
    clci_work_end_date: employeeEditForm.value.clci_work_end_date || null,
    clci_phone: employeeEditForm.value.clci_phone || null,
    clci_email: employeeEditForm.value.clci_email || null,
    clci_zipcode: employeeEditForm.value.clci_zipcode || null,
    clci_addr1: employeeEditForm.value.clci_addr1 || null,
    clci_addr2: employeeEditForm.value.clci_addr2 || null,
  };
  if (ssnInput) {
    payload.clci_ssn_back = ssnInput;
  }

  employeeSaving.value = true;
  try {
    await employeeApi.update(
      memberCode.value,
      selectedEmployee.value.clci_idx,
      payload,
      source
    );
    closeEmployeeDetail();
    await loadEmployeeList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '수정에 실패했습니다.';
    alert(`사원 수정 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    employeeSaving.value = false;
  }
};

const deleteEmployee = async () => {
  if (
    !selectedEmployee.value ||
    selectedEmployee.value.clci_source !== 'manual' ||
    employeeDeleting.value ||
    !memberCode.value
  ) {
    return;
  }
  if (!confirm(`「${selectedEmployee.value.clci_name}」 사원을 삭제하시겠습니까?`)) return;
  employeeDeleting.value = true;
  try {
    await employeeApi.delete(memberCode.value, selectedEmployee.value.clci_idx);
    closeEmployeeDetail();
    await loadEmployeeList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '삭제에 실패했습니다.';
    alert(`사원 삭제 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    employeeDeleting.value = false;
  }
};

// ── 수급자 (LTCS 자동수집 + 직접등록 UNION) ──
const beneficiaryLoading = ref(false);
const beneficiarySaving = ref(false);
const beneficiaryDeleting = ref(false);
const beneficiaryList = ref<any[]>([]);
const beneficiaryStats = ref({
  total: 0,
  ipso: 0,
  toiso: 0,
  monthEnter: 0,
  monthLeave: 0,
});
const beneficiaryMeta = ref<{ lastAutoCollectWdate?: string | null; yearMonth?: string }>({});
const beneficiaryStatusFilter = ref('');
const beneficiarySearchText = ref('');
const beneficiarySortKey = ref('clsr_recipient_name');
const beneficiarySortOrder = ref<'asc' | 'desc'>('asc');
const showBeneficiaryQuickAdd = ref(false);
const beneficiaryDetailDialog = ref(false);
const selectedBeneficiary = ref<any>(null);

const beneficiaryEditForm = ref({
  clsr_recipient_name: '',
  clsr_approval_no: '',
  clsr_birth_date: '',
  clsr_ssn_front: '',
  clsr_ssn_back: '',
  clsr_grade: '',
  clsr_service_type: '',
  clsr_enter_date: '',
  clsr_leave_date: '',
  clsr_phone: '',
  clsr_zipcode: '',
  clsr_addr1: '',
  clsr_addr2: '',
});
const beneficiaryHistory = ref<any[]>([]);
const beneficiaryHistoryLoading = ref(false);
const beneficiaryStayActing = ref(false);
const stayLeaveDate = ref('');
const reenterDate = ref('');
const reenterGrade = ref('');
const beneficiaryDetailTab = ref<'info' | 'history'>('info');
const beneficiaryOriginal = ref({ grade: '', enter: '', leave: '' });

const todayYmd = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

const beneficiarySavedLeave = computed(() => toDateOnly(beneficiaryOriginal.value.leave));
const beneficiaryHasLeft = computed(() => {
  const leave = beneficiarySavedLeave.value;
  return !!leave && leave !== '0000-00-00' && leave < todayYmd();
});

const formatDotDate = (value: string | null | undefined) => {
  const date = toDateOnly(value);
  return date ? date.replace(/-/g, '.') : '';
};

const beneficiaryStayHeadline = computed(() => {
  if (beneficiaryHasLeft.value) return '퇴소했습니다';
  if (beneficiaryOriginal.value.enter || beneficiarySavedLeave.value) return '입소 중입니다';
  return '입소일이 없습니다';
});

const beneficiaryStayDetail = computed(() => {
  const enter = formatDotDate(beneficiaryOriginal.value.enter);
  const leave = formatDotDate(beneficiarySavedLeave.value);
  const grade = beneficiaryOriginal.value.grade;
  if (!enter && !leave) return '입소일을 입력한 뒤 저장하세요.';
  const parts = [`입소 ${enter || '없음'}`];
  if (leave) parts.push(beneficiaryHasLeft.value ? `퇴소 ${leave}` : `퇴소 예정 ${leave}`);
  if (grade) parts.push(grade);
  return parts.join(' · ');
});

const isBeneficiaryReenter = (item: { past_stay_count?: number; month_status?: string }) =>
  Number(item?.past_stay_count || 0) > 0 && item?.month_status === '입소';

const historyItemTitle = (item: any) => {
  if (item.clrh_kind === 'grade') {
    const when = formatDotDate(item.clrh_effective_date) || '날짜 없음';
    return `${when} 등급 ${item.clrh_prev_grade || '없음'} → ${item.clrh_grade || '없음'}`;
  }
  const enter = formatDotDate(item.clrh_enter_date) || '입소일 없음';
  const leave = formatDotDate(item.clrh_leave_date) || '퇴소일 없음';
  return `${enter} – ${leave}`;
};

const historyItemMeta = (item: any) => {
  if (item.clrh_kind === 'grade') return '등급 변경';
  return item.clrh_grade ? `지난 이용 · ${item.clrh_grade}` : '지난 이용';
};

const benSsnRevealing = ref(false);
const benSsnRevealed = ref(false);
const benSsnRevealedValue = ref('');
const beneficiarySsnEditing = ref(false);

const filteredBeneficiaryList = computed(() => {
  let result = [...beneficiaryList.value];
  if (beneficiaryStatusFilter.value === '입소') {
    result = result.filter((r) => r.month_status === '입소');
  } else if (beneficiaryStatusFilter.value === '퇴소') {
    result = result.filter((r) => r.month_status === '퇴소');
  }
  if (beneficiarySearchText.value) {
    const keyword = beneficiarySearchText.value.toLowerCase();
    result = result.filter(
      (r) =>
        r.clsr_recipient_name?.toLowerCase().includes(keyword) ||
        r.clsr_approval_no?.toLowerCase().includes(keyword) ||
        r.clsr_phone?.includes(keyword)
    );
  }
  if (beneficiarySortKey.value) {
    result.sort((a, b) => {
      let aVal: string | number = a[beneficiarySortKey.value];
      let bVal: string | number = b[beneficiarySortKey.value];
      if (aVal == null) aVal = '';
      if (bVal == null) bVal = '';
      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();
      if (aVal < bVal) return beneficiarySortOrder.value === 'asc' ? -1 : 1;
      if (aVal > bVal) return beneficiarySortOrder.value === 'asc' ? 1 : -1;
      return 0;
    });
  }
  return result;
});

const toggleBeneficiarySort = (key: string) => {
  if (beneficiarySortKey.value === key) {
    beneficiarySortOrder.value = beneficiarySortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    beneficiarySortKey.value = key;
    beneficiarySortOrder.value = 'asc';
  }
};

const getBeneficiarySortIcon = (key: string) => {
  if (beneficiarySortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return beneficiarySortOrder.value === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down';
};

const loadBeneficiaryList = async () => {
  if (!memberCode.value) return;
  beneficiaryLoading.value = true;
  try {
    const res = await beneficiaryApi.getList(memberCode.value, {
      yearMonth: selectedYearMonth.value,
      limit: 2000,
    });
    const data = res.data?.data;
    beneficiaryList.value = data?.list || [];
    if (data?.stats) {
      beneficiaryStats.value = {
        total: data.stats.total ?? 0,
        ipso: data.stats.ipso ?? 0,
        toiso: data.stats.toiso ?? 0,
        monthEnter: data.stats.monthEnter ?? 0,
        monthLeave: data.stats.monthLeave ?? 0,
      };
    }
    if (data?.meta) {
      beneficiaryMeta.value = {
        lastAutoCollectWdate: data.meta.lastAutoCollectWdate ?? null,
        yearMonth: data.meta.yearMonth,
      };
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`수급자 목록 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
    beneficiaryList.value = [];
  } finally {
    beneficiaryLoading.value = false;
  }
};

const startBeneficiarySsnEdit = () => {
  beneficiarySsnEditing.value = true;
  benSsnRevealed.value = false;
  beneficiaryEditForm.value.clsr_ssn_back = '';
};

const cancelBeneficiarySsnEdit = () => {
  beneficiarySsnEditing.value = false;
  beneficiaryEditForm.value.clsr_ssn_back = '';
};

const openBeneficiaryDetail = (item: any) => {
  selectedBeneficiary.value = item;
  benSsnRevealed.value = false;
  benSsnRevealedValue.value = '';
  beneficiarySsnEditing.value = false;
  const birth = formatDate(item.clsr_birth_date) === '-' ? '' : formatDate(item.clsr_birth_date);
  const ssnFrontDerived = formatSsnFront(birth);
  beneficiaryEditForm.value = {
    clsr_recipient_name: item.clsr_recipient_name || '',
    clsr_approval_no: item.clsr_approval_no || '',
    clsr_birth_date: birth,
    clsr_ssn_front: item.clsr_ssn_front || (ssnFrontDerived !== '******' ? ssnFrontDerived : ''),
    clsr_ssn_back: '',
    clsr_grade: item.clsr_grade || '',
    clsr_service_type: item.clsr_service_type || '',
    clsr_enter_date: formatDate(item.clsr_enter_date) === '-' ? '' : formatDate(item.clsr_enter_date),
    clsr_leave_date: formatDate(item.clsr_leave_date) === '-' ? '' : formatDate(item.clsr_leave_date),
    clsr_phone: item.clsr_phone || '',
    clsr_zipcode: item.clsr_zipcode || '',
    clsr_addr1: item.clsr_addr1 || '',
    clsr_addr2: item.clsr_addr2 || '',
  };
  beneficiaryDetailTab.value = 'info';
  syncBeneficiaryStayDraft();
  beneficiaryDetailDialog.value = true;
  loadBeneficiaryHistory();
};

const syncBeneficiaryStayDraft = () => {
  beneficiaryOriginal.value = {
    grade: beneficiaryEditForm.value.clsr_grade.trim(),
    enter: beneficiaryEditForm.value.clsr_enter_date,
    leave: beneficiaryEditForm.value.clsr_leave_date,
  };
  stayLeaveDate.value = todayYmd();
  reenterDate.value = todayYmd();
  reenterGrade.value = beneficiaryEditForm.value.clsr_grade;
};

const loadBeneficiaryHistory = async () => {
  if (!selectedBeneficiary.value || !memberCode.value) {
    beneficiaryHistory.value = [];
    return;
  }
  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  beneficiaryHistoryLoading.value = true;
  try {
    const res = await beneficiaryApi.getHistory(
      memberCode.value,
      source,
      selectedBeneficiary.value.clsr_idx
    );
    beneficiaryHistory.value = res.data?.data || [];
  } catch {
    beneficiaryHistory.value = [];
  } finally {
    beneficiaryHistoryLoading.value = false;
  }
};

const closeBeneficiaryDetail = () => {
  beneficiaryDetailDialog.value = false;
  beneficiaryDetailTab.value = 'info';
  selectedBeneficiary.value = null;
  beneficiaryHistory.value = [];
  benSsnRevealed.value = false;
  benSsnRevealedValue.value = '';
  beneficiarySsnEditing.value = false;
};

// 생년월일이 바뀌면 주민번호 앞자리가 비어 있을 때 자동 채움
watch(
  () => beneficiaryEditForm.value.clsr_birth_date,
  (birth) => {
    if (beneficiaryEditForm.value.clsr_ssn_front) return;
    const derived = formatSsnFront(birth);
    if (derived !== '******') {
      beneficiaryEditForm.value.clsr_ssn_front = derived;
    }
  }
);

const revealBeneficiarySsn = async () => {
  if (!selectedBeneficiary.value || !memberCode.value || benSsnRevealing.value) return;

  if (benSsnRevealed.value) {
    benSsnRevealed.value = false;
    benSsnRevealedValue.value = '';
    return;
  }

  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  benSsnRevealing.value = true;
  try {
    const res = await beneficiaryApi.revealSsn(memberCode.value, source, selectedBeneficiary.value.clsr_idx);
    const plain = res.data?.data?.clsr_ssn_back;
    if (!plain) {
      alert('저장된 주민번호 뒷자리가 없습니다.');
      return;
    }
    benSsnRevealedValue.value = plain;
    benSsnRevealed.value = true;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '조회에 실패했습니다.';
    alert(`주민번호 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    benSsnRevealing.value = false;
  }
};

const saveBeneficiaryEdit = async () => {
  if (!selectedBeneficiary.value || beneficiarySaving.value || !memberCode.value) return;

  const ssnFront = beneficiaryEditForm.value.clsr_ssn_front.replace(/\D/g, '');
  if (ssnFront && ssnFront.length !== 6) {
    alert('주민번호 앞자리는 숫자 6자리여야 합니다.');
    return;
  }
  const ssnBack = beneficiaryEditForm.value.clsr_ssn_back.replace(/\D/g, '');
  if (ssnBack && !isValidSsnBack(ssnBack)) {
    alert('주민번호 뒷자리는 숫자 7자리여야 합니다.');
    return;
  }

  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  const payload: Record<string, unknown> = {
    clsr_recipient_name: beneficiaryEditForm.value.clsr_recipient_name.trim(),
    clsr_approval_no: beneficiaryEditForm.value.clsr_approval_no || null,
    clsr_birth_date: beneficiaryEditForm.value.clsr_birth_date || null,
    clsr_grade: beneficiaryEditForm.value.clsr_grade || null,
    clsr_service_type: beneficiaryEditForm.value.clsr_service_type || null,
    clsr_enter_date: beneficiaryEditForm.value.clsr_enter_date || null,
    clsr_leave_date: beneficiaryEditForm.value.clsr_leave_date || null,
    clsr_phone: beneficiaryEditForm.value.clsr_phone || null,
    clsr_zipcode: beneficiaryEditForm.value.clsr_zipcode || null,
    clsr_addr1: beneficiaryEditForm.value.clsr_addr1 || null,
    clsr_addr2: beneficiaryEditForm.value.clsr_addr2 || null,
    clsr_ssn_front: ssnFront || null,
  };
  if (ssnBack) {
    payload.clsr_ssn_back = ssnBack;
  }

  beneficiarySaving.value = true;
  try {
    await beneficiaryApi.updateLtcsInfo(memberCode.value, source, selectedBeneficiary.value.clsr_idx, payload);
    closeBeneficiaryDetail();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '수정에 실패했습니다.';
    alert(`수급자 수정 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiarySaving.value = false;
  }
};

const patchBeneficiaryStay = async (payload: Record<string, unknown>) => {
  if (!selectedBeneficiary.value || !memberCode.value) return;
  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  const clsrIdx = selectedBeneficiary.value.clsr_idx;
  beneficiaryStayActing.value = true;
  try {
    await beneficiaryApi.updateLtcsInfo(memberCode.value, source, clsrIdx, payload);
    const res = await beneficiaryApi.getLtcsById(memberCode.value, source, clsrIdx);
    const row = res.data?.data;
    if (row) {
      selectedBeneficiary.value = { ...selectedBeneficiary.value, ...row };
      const enter = formatDate(row.clsr_enter_date);
      const leave = formatDate(row.clsr_leave_date);
      beneficiaryEditForm.value.clsr_enter_date = enter === '-' ? '' : enter;
      beneficiaryEditForm.value.clsr_leave_date = leave === '-' ? '' : leave;
      beneficiaryEditForm.value.clsr_grade = row.clsr_grade || '';
      syncBeneficiaryStayDraft();
    }
    await loadBeneficiaryHistory();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '기록에 실패했습니다.';
    alert(message);
  } finally {
    beneficiaryStayActing.value = false;
  }
};

const recordBeneficiaryLeave = async () => {
  if (!selectedBeneficiary.value || beneficiaryStayActing.value) return;
  const leave = stayLeaveDate.value;
  if (!leave) {
    alert('퇴소일을 입력하세요.');
    return;
  }
  const enter = beneficiaryOriginal.value.enter;
  if (enter && leave < enter) {
    alert('퇴소일은 입소일 이후여야 합니다.');
    return;
  }
  if (!confirm(`${formatDotDate(leave)}로 퇴소 처리합니다.\n입소일과 등급은 유지됩니다.`)) return;
  await patchBeneficiaryStay({ clsr_leave_date: leave });
};

const recordBeneficiaryReenter = async () => {
  if (!selectedBeneficiary.value || beneficiaryStayActing.value) return;
  const enter = reenterDate.value;
  if (!enter) {
    alert('새 입소일을 입력하세요.');
    return;
  }
  const oldLeave = beneficiaryOriginal.value.leave;
  const oldEnter = beneficiaryOriginal.value.enter;
  if (oldLeave && enter < oldLeave) {
    alert('다시 입소일은 퇴소일 이후여야 합니다.');
    return;
  }
  if (oldEnter && enter === oldEnter) {
    alert('새 입소일은 지난 입소일과 달라야 합니다.');
    return;
  }
  const grade = reenterGrade.value.trim();
  const period = `${formatDotDate(oldEnter) || '입소일 없음'} ~ ${formatDotDate(oldLeave)}`;
  const gradeNote = beneficiaryOriginal.value.grade ? `, ${beneficiaryOriginal.value.grade}` : '';
  if (!confirm(`${formatDotDate(enter)}부터 다시 입소로 기록합니다.\n지난 이용(${period}${gradeNote})은 이력에 남습니다.`)) return;
  await patchBeneficiaryStay({
    clsr_enter_date: enter,
    clsr_leave_date: null,
    clsr_grade: grade || null,
  });
};

const deleteBeneficiary = async () => {
  if (
    !selectedBeneficiary.value ||
    selectedBeneficiary.value.clsr_source !== 'manual' ||
    beneficiaryDeleting.value ||
    !memberCode.value
  ) return;
  if (!confirm(`「${selectedBeneficiary.value.clsr_recipient_name}」 수급자를 삭제하시겠습니까?`)) return;
  beneficiaryDeleting.value = true;
  try {
    await beneficiaryApi.deleteLtcsManual(memberCode.value, selectedBeneficiary.value.clsr_idx);
    closeBeneficiaryDetail();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '삭제에 실패했습니다.';
    alert(`수급자 삭제 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiaryDeleting.value = false;
  }
};

const newBeneficiaryForm = ref({
  clsr_recipient_name: '',
  clsr_approval_no: '',
  clsr_birth_date: '',
  clsr_service_type: '',
  clsr_enter_date: '',
  clsr_phone: '',
});

const isValidRecipientId = (value: string) => {
  if (!value || value === 'L') return true;
  return /^L\d{10}$/.test(value);
};

const onRecipientIdFocus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (!input.value) input.value = 'L';
  setTimeout(() => input.setSelectionRange(input.value.length, input.value.length), 0);
};

const onRecipientIdBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (input.value === 'L') {
    input.value = '';
    newBeneficiaryForm.value.clsr_approval_no = '';
  }
};

const onRecipientIdInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.toUpperCase();
  if (value.length > 0 && value[0] !== 'L') {
    value = /^\d/.test(value) ? `L${value}` : `L${value.slice(1)}`;
  }
  if (!value) value = 'L';
  if (value.length > 1) value = `L${value.slice(1).replace(/\D/g, '')}`;
  value = value.slice(0, 11);
  input.value = value;
  newBeneficiaryForm.value.clsr_approval_no = value === 'L' ? '' : value;
};

const canSaveNew = computed(() => {
  const nameValid = !!newBeneficiaryForm.value.clsr_recipient_name.trim();
  const birthValid = !!newBeneficiaryForm.value.clsr_birth_date;
  const approvalValid =
    !newBeneficiaryForm.value.clsr_approval_no ||
    isValidRecipientId(newBeneficiaryForm.value.clsr_approval_no);
  return nameValid && birthValid && approvalValid;
});

const saveNewBeneficiary = async () => {
  if (!canSaveNew.value || beneficiarySaving.value || !memberCode.value) return;
  beneficiarySaving.value = true;
  try {
    await beneficiaryApi.create(memberCode.value, {
      useLtcs: true,
      clsr_recipient_name: newBeneficiaryForm.value.clsr_recipient_name.trim(),
      clsr_birth_date: newBeneficiaryForm.value.clsr_birth_date,
      clsr_approval_no: newBeneficiaryForm.value.clsr_approval_no || undefined,
      clsr_service_type: newBeneficiaryForm.value.clsr_service_type || undefined,
      clsr_enter_date: newBeneficiaryForm.value.clsr_enter_date || undefined,
      clsr_phone: newBeneficiaryForm.value.clsr_phone || undefined,
    });
    newBeneficiaryForm.value = {
      clsr_recipient_name: '',
      clsr_approval_no: '',
      clsr_birth_date: '',
      clsr_service_type: '',
      clsr_enter_date: '',
      clsr_phone: '',
    };
    showBeneficiaryQuickAdd.value = false;
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '등록에 실패했습니다.';
    alert(`수급자 등록 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiarySaving.value = false;
  }
};

// ── 수급자 엑셀 업로드 (인사관리 + 회계 동시 반영) ──
const beneficiaryExcelModal = ref(false);
const beneficiaryExcelInputRef = ref<HTMLInputElement | null>(null);
const beneficiaryExcelFile = ref<File | null>(null);
const beneficiaryExcelFileName = ref('');
const beneficiaryExcelUploading = ref(false);
const beneficiaryExcelMessage = ref('');
const beneficiaryExcelError = ref(false);

const openBeneficiaryExcelModal = () => {
  beneficiaryExcelFile.value = null;
  beneficiaryExcelFileName.value = '';
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  beneficiaryExcelModal.value = true;
};

const closeBeneficiaryExcelModal = () => {
  if (beneficiaryExcelUploading.value) return;
  beneficiaryExcelModal.value = false;
};

const downloadBeneficiaryTemplate = async () => {
  try {
    await beneficiaryApi.downloadTemplate();
  } catch (error: any) {
    alert(error.response?.data?.message || error.message || '양식 다운로드 실패');
  }
};

const onBeneficiaryExcelSelected = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0] || null;
  beneficiaryExcelFile.value = file;
  beneficiaryExcelFileName.value = file?.name || '';
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  if (input) input.value = '';
};

const uploadBeneficiaryExcel = async () => {
  if (!beneficiaryExcelFile.value || !memberCode.value || beneficiaryExcelUploading.value) return;
  beneficiaryExcelUploading.value = true;
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  try {
    const formData = new FormData();
    formData.append('file', beneficiaryExcelFile.value);
    const res = await beneficiaryApi.bulkCreate(memberCode.value, formData);
    const msg = res.data?.message || '업로드가 완료되었습니다.';
    beneficiaryExcelMessage.value = msg;
    beneficiaryExcelError.value = false;
    await loadBeneficiaryList();
    alert(msg);
    beneficiaryExcelModal.value = false;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '업로드에 실패했습니다.';
    beneficiaryExcelMessage.value = message;
    beneficiaryExcelError.value = true;
  } finally {
    beneficiaryExcelUploading.value = false;
  }
};

// ── 공통 ──
const avatarColors = [
  '#1e3a5f', '#2e7d32', '#c62828', '#f57c00', '#6a1b9a',
  '#00838f', '#4527a0', '#ad1457', '#00695c', '#bf360c'
];

const getAvatarColor = (name: string) => {
  if (!name) return '#90a4ae';
  return avatarColors[name.charCodeAt(0) % avatarColors.length];
};

const getInitial = (name: string) => (name ? name.charAt(0) : '?');

const formatDate = (dateStr: string | null) => {
  if (!dateStr) return '-';
  return dateStr.split('T')[0];
};

const employmentLines = (item: any): EmploymentLine[] => {
  const lines = Array.isArray(item?.employments) ? item.employments : [];
  if (lines.length) return lines;
  return [{
    clci_source: item?.clci_source === 'manual' ? 'manual' : 'auto',
    clci_source_label: item?.clci_source_label || (item?.clci_source === 'manual' ? '직접등록' : '자동수집'),
    clci_idx: item?.clci_idx,
    clci_work_start_date: item?.clci_work_start_date,
    clci_work_end_date: item?.clci_work_end_date,
    clci_wdate: item?.clci_wdate,
    clci_rdate: item?.clci_rdate,
  }];
};

const hasSeveralEmployments = (item: any) => employmentLines(item).length > 1;

const employmentSourceLabel = (source?: string) => (source === 'manual' ? '직접등록' : '자동수집');

/** 임금·증명서에 쓰는 입사일. 직접등록 입사일이 있으면 그 기록 */
const wageEmployment = (item: any): EmploymentLine | null => {
  const lines = employmentLines(item);
  const dated = lines.filter((line) => toDateOnly(line.clci_work_start_date));
  const manuals = dated.filter((line) => line.clci_source === 'manual');
  const pool = manuals.length ? manuals : (dated.length ? dated : lines);
  return [...pool].sort((a, b) => {
    const aOpen = a.month_status === '현원' || (!a.month_status && !leaveDateOf(a)) ? 0 : 1;
    const bOpen = b.month_status === '현원' || (!b.month_status && !leaveDateOf(b)) ? 0 : 1;
    if (aOpen !== bOpen) return aOpen - bOpen;
    return toDateOnly(b.clci_work_start_date).localeCompare(toDateOnly(a.clci_work_start_date));
  })[0] || null;
};

const shownEmployment = (item: any): EmploymentLine | null => wageEmployment(item);

const otherJoinLines = (item: any): EmploymentLine[] => {
  const picked = shownEmployment(item);
  const used = toDateOnly(picked?.clci_work_start_date);
  return employmentLines(item).filter((line) => {
    if (picked && line.clci_source === picked.clci_source && Number(line.clci_idx) === Number(picked.clci_idx)) {
      return false;
    }
    const start = toDateOnly(line.clci_work_start_date);
    return !!start && start !== used;
  });
};

const otherJoinCaption = (item: any, line: EmploymentLine) => {
  const word = line.clci_source === 'manual' ? '직접' : '수집';
  const full = formatDate(line.clci_work_start_date);
  const base = formatDate(shownEmployment(item)?.clci_work_start_date);
  const shown = full !== '-' && base !== '-' && full.slice(0, 4) === base.slice(0, 4)
    ? full.slice(5)
    : full;
  return `${word} ${shown}`;
};

const joinDateHint = (item: any) => {
  const others = otherJoinLines(item);
  if (!others.length) return '';
  const picked = shownEmployment(item);
  const used = employmentSourceLabel(picked?.clci_source);
  const date = formatDate(picked?.clci_work_start_date);
  const rest = others
    .map((line) => `${employmentSourceLabel(line.clci_source)} ${formatDate(line.clci_work_start_date)}`)
    .join(', ');
  return `임금에는 ${used} ${date}을 사용합니다. 다른 입사일은 ${rest}입니다.`;
};

const latestCollectAt = (item: any) => {
  let latest = '';
  employmentLines(item).forEach((line) => {
    const stamp = String(line.clci_wdate || line.clci_rdate || '');
    if (stamp > latest) latest = stamp;
  });
  return latest || null;
};

const isWageEmployment = (item: any, line: EmploymentLine) => {
  if (!hasSeveralEmployments(item)) return false;
  const picked = wageEmployment(item);
  if (!picked) return false;
  return picked.clci_source === line.clci_source && Number(picked.clci_idx) === Number(line.clci_idx);
};

const wageEmploymentNote = (item: any) => {
  const picked = wageEmployment(item);
  if (!picked) return '';
  const used = employmentSourceLabel(picked.clci_source);
  const date = formatDate(picked.clci_work_start_date);
  const editing = employmentSourceLabel(item?.clci_source);
  const editsApplied = isWageEmployment(item, {
    clci_source: item?.clci_source,
    clci_idx: item?.clci_idx,
  });
  if (editsApplied) {
    return `임금과 증명서에는 이 ${used} 입사일 ${date}을 사용합니다.`;
  }
  return `임금과 증명서에는 ${used} 입사일 ${date}을 사용합니다. 아래 저장은 ${editing} 기록만 바꿉니다.`;
};

const toDateOnly = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  return String(dateStr).split('T')[0];
};

const leaveDateOf = (row: { clci_work_end_date?: string | null }) => {
  const d = toDateOnly(row.clci_work_end_date);
  if (!d || d === '0000-00-00' || d === '9999-12-31') return '';
  return d;
};

/** 같은 사람의 이전 근무에 퇴사일이 있고, 이 줄은 퇴사일이 없으면 재입사 */
const isEmployeeRehire = (item: {
  clci_name?: string;
  clci_birth_date?: string | null;
  clci_work_start_date?: string | null;
  clci_work_end_date?: string | null;
  clci_source?: string;
  clci_idx?: number;
}) => {
  if (leaveDateOf(item)) return false;
  const name = String(item.clci_name || '').trim().toLowerCase();
  const birth = toDateOnly(item.clci_birth_date);
  const start = toDateOnly(item.clci_work_start_date);
  if (!name || !birth) return false;
  return employeeList.value.some((row) => {
    if (row.clci_source === item.clci_source && row.clci_idx === item.clci_idx) return false;
    if (String(row.clci_name || '').trim().toLowerCase() !== name) return false;
    if (toDateOnly(row.clci_birth_date) !== birth) return false;
    if (!leaveDateOf(row)) return false;
    const rowStart = toDateOnly(row.clci_work_start_date);
    return !start || !rowStart || rowStart <= start;
  });
};

const INVALID_SCHEDULE_CERT_NUMBERS = new Set(['', '9999-12-31']);

const isValidScheduleRecipientId = (approvalNo: string | null | undefined): boolean => {
  const code = (approvalNo || '').trim();
  return code.length > 0 && !INVALID_SCHEDULE_CERT_NUMBERS.has(code);
};

const showBeneficiaryCalendar = ref(false);
const showEmployeeCalendar = ref(false);
const showAllBeneficiarySchedule = ref(false);
const beneficiaryPdfLoading = ref(false);
const employeePdfLoading = ref(false);
const calendarBeneficiary = ref<CalendarBeneficiary | null>(null);
const calendarCaregiver = ref<CalendarCaregiver | null>(null);

const calendarBeneficiaryList = computed<CalendarBeneficiary[]>(() =>
  filteredBeneficiaryList.value
    .filter((item) => isValidScheduleRecipientId(item.clsr_approval_no))
    .map((item) => ({
      patient_code: item.clsr_approval_no.trim(),
      patient_name: item.clsr_recipient_name,
    }))
);

const calendarCaregiverList = computed<CalendarCaregiver[]>(() =>
  filteredEmployeeList.value
    .filter((item) => item.clci_name && toDateOnly(item.clci_birth_date))
    .map((item) => ({
      emp_name: item.clci_name,
      emp_birth: toDateOnly(item.clci_birth_date),
      emp_job: item.clci_job_type || '요양보호사',
    }))
);

const canOpenBeneficiarySchedule = (item: { clsr_approval_no?: string | null }) =>
  isValidScheduleRecipientId(item.clsr_approval_no);

const canOpenEmployeeSchedule = (item: { clci_name?: string; clci_birth_date?: string | null }) =>
  !!(item.clci_name && toDateOnly(item.clci_birth_date));

const openBeneficiarySchedule = (item: {
  clsr_approval_no: string;
  clsr_recipient_name: string;
}) => {
  if (!canOpenBeneficiarySchedule(item)) {
    alert('수급자 인정번호가 등록되어 있어야 일정계획을 조회할 수 있습니다.');
    return;
  }
  calendarBeneficiary.value = {
    patient_code: item.clsr_approval_no.trim(),
    patient_name: item.clsr_recipient_name,
  };
  showBeneficiaryCalendar.value = true;
};

const openBeneficiaryScheduleFromDetail = () => {
  if (!selectedBeneficiary.value) return;
  openBeneficiarySchedule(selectedBeneficiary.value);
};

const openEmployeeSchedule = (item: {
  clci_name: string;
  clci_birth_date: string | null;
  clci_job_type?: string | null;
}) => {
  if (!canOpenEmployeeSchedule(item)) {
    alert('요양보호사 이름과 생년월일이 있어야 일정계획을 조회할 수 있습니다.');
    return;
  }
  calendarCaregiver.value = {
    emp_name: item.clci_name,
    emp_birth: toDateOnly(item.clci_birth_date),
    emp_job: item.clci_job_type || '요양보호사',
  };
  showEmployeeCalendar.value = true;
};

const openEmployeeScheduleFromDetail = () => {
  if (!selectedEmployee.value) return;
  openEmployeeSchedule(selectedEmployee.value);
};

const onOpenRecipientFromAllSchedule = (recipient: CalendarBeneficiary) => {
  showAllBeneficiarySchedule.value = false;
  calendarBeneficiary.value = recipient;
  showBeneficiaryCalendar.value = true;
};

const downloadAllBeneficiaryPdf = async () => {
  if (!memberCode.value) return;
  beneficiaryPdfLoading.value = true;
  try {
    const fetchPdf = (omitBizGubun: boolean) =>
      homeScheduleApi.downloadAllBeneficiariesPdf(
        memberCode.value,
        scheduleYearMonth.value,
        omitBizGubun ? undefined : selectedBizGubun.value || undefined
      );

    let res;
    try {
      res = await fetchPdf(false);
    } catch (error: unknown) {
      const status = (error as any)?.response?.status;
      if (status === 404 && selectedBizGubun.value) {
        res = await fetchPdf(true);
      } else {
        throw error;
      }
    }
    downloadPdfBlob(res.data, `전체수급자_일정표_${scheduleYearMonth.value}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '전체 수급자 PDF 출력에 실패했습니다.');
    alert(`전체 PDF 출력 실패: ${message}`);
  } finally {
    beneficiaryPdfLoading.value = false;
  }
};

const downloadAllCaregiverPdf = async () => {
  if (!memberCode.value) return;
  employeePdfLoading.value = true;
  try {
    const fetchPdf = (omitBizGubun: boolean) =>
      homeScheduleApi.downloadAllCaregiversPdf(
        memberCode.value,
        scheduleYearMonth.value,
        omitBizGubun ? undefined : selectedBizGubun.value || undefined
      );

    let res;
    try {
      res = await fetchPdf(false);
    } catch (error: unknown) {
      const status = (error as any)?.response?.status;
      if (status === 404 && selectedBizGubun.value) {
        res = await fetchPdf(true);
      } else {
        throw error;
      }
    }
    downloadPdfBlob(res.data, `전체요양보호사_일정표_${scheduleYearMonth.value}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '전체 요양보호사 PDF 출력에 실패했습니다.');
    alert(`전체 PDF 출력 실패: ${message}`);
  } finally {
    employeePdfLoading.value = false;
  }
};

const formatDateTime = (dateStr: string | null) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr).replace('T', ' ').slice(0, 16);
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${y}.${mo}.${day} ${h}:${mi}`;
};

const loadAll = async () => {
  await Promise.all([loadEmployeeList(), loadBeneficiaryList()]);
};

watch(selectedBizGubun, () => {
  newEmployeeRows.value.forEach((row) => {
    if (row.clci_job_type && !isEmployeePosition(row.clci_job_type)) {
      row.clci_job_type = defaultPosition.value;
    }
  });
});

watch(memberCode, (code) => {
  if (code) {
    loadAll();
  }
});

watch(
  () => memberData?.value?.m_code,
  (code) => {
    if (code && !route.params.memberCode) loadAll();
  }
);

watch(
  () => route.query.tab,
  (tab) => {
    if (tab === 'beneficiary' || tab === 'employee') {
      activeTab.value = tab;
    }
  },
  { immediate: true }
);

onMounted(async () => {
  const tab = route.query.tab as string;
  if (tab === 'beneficiary' || tab === 'employee') {
    activeTab.value = tab;
  }
  await refreshJobTypes();
  newEmployeeRows.value.forEach((row) => {
    if (!row.clci_job_type) {
      row.clci_job_type = defaultPosition.value;
    }
  });
  if (memberCode.value) {
    loadAll();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (activeTab.value === 'employee')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[77] || (_cache[77] = _createElementVNode("div", { class: "group-label" }, "현황 필터", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: employeeStatusFilter.value === '' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (employeeStatusFilter.value = ''))
                      }, "전체", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: employeeStatusFilter.value === '현원' }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (employeeStatusFilter.value = '현원'))
                      }, "현원", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: employeeStatusFilter.value === '퇴사' }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (employeeStatusFilter.value = '퇴사'))
                      }, "퇴사", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab filter-tab--ssn", { active: employeeStatusFilter.value === '주민번호미등록' }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (employeeStatusFilter.value = '주민번호미등록'))
                      }, "주민번호 미등록", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab filter-tab--app", { active: employeeStatusFilter.value === '앱연동' }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (employeeStatusFilter.value = '앱연동'))
                      }, "앱연동", 2)
                    ])
                  ]),
                  (employeeMeta.value.lastAutoCollectWdate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_v_icon, {
                          size: "13",
                          color: "#64748b"
                        }, {
                          default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                            _createTextVNode("mdi-cloud-download-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", null, "자동수집 " + _toDisplayString(formatDateTime(employeeMeta.value.lastAutoCollectWdate)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot total" }),
                        _createElementVNode("span", { class: "label" }, "전체")
                      ], -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(employeeStats.value.total) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[80] || (_cache[80] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot active" }),
                        _createElementVNode("span", { class: "label" }, "현원")
                      ], -1)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(employeeStats.value.hyunwon) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[81] || (_cache[81] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot inactive" }),
                        _createElementVNode("span", { class: "label" }, "퇴사")
                      ], -1)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(employeeStats.value.toesaw) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[82] || (_cache[82] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot ssn-missing" }),
                        _createElementVNode("span", { class: "label" }, "주민번호 미등록")
                      ], -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["value", { warn: employeeSsnMissingCount.value > 0 }])
                      }, _toDisplayString(employeeSsnMissingCount.value) + "명", 3)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot app-link" }),
                        _createElementVNode("span", { class: "label" }, "앱연동")
                      ], -1)),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(employeeAppLinkedCount.value) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, "당월입사 " + _toDisplayString(employeeStats.value.monthEnter) + " · 당월퇴사 " + _toDisplayString(employeeStats.value.monthLeave), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[85] || (_cache[85] = _createElementVNode("span", { class: "search-label" }, "사원 검색", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((employeeSearchText).value = $event)),
                        type: "text",
                        placeholder: "이름 검색...",
                        class: "search-input"
                      }, null, 512), [
                        [_vModelText, employeeSearchText.value]
                      ]),
                      (employeeSearchText.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "search-clear",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (employeeSearchText.value = ''))
                          }, [
                            _createVNode(_component_v_icon, { size: "10" }, {
                              default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[86] || (_cache[86] = _createElementVNode("div", { class: "group-label" }, "현황 필터", -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: beneficiaryStatusFilter.value === '' }]),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (beneficiaryStatusFilter.value = ''))
                      }, "전체", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: beneficiaryStatusFilter.value === '입소' }]),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (beneficiaryStatusFilter.value = '입소'))
                      }, "입소", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["filter-tab", { active: beneficiaryStatusFilter.value === '퇴소' }]),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (beneficiaryStatusFilter.value = '퇴소'))
                      }, "퇴소", 2)
                    ])
                  ]),
                  (beneficiaryMeta.value.lastAutoCollectWdate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_v_icon, {
                          size: "13",
                          color: "#64748b"
                        }, {
                          default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                            _createTextVNode("mdi-cloud-download-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", null, "자동수집 " + _toDisplayString(formatDateTime(beneficiaryMeta.value.lastAutoCollectWdate)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[88] || (_cache[88] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot total" }),
                        _createElementVNode("span", { class: "label" }, "전체")
                      ], -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(beneficiaryStats.value.total) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[89] || (_cache[89] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot active" }),
                        _createElementVNode("span", { class: "label" }, "입소")
                      ], -1)),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(beneficiaryStats.value.ipso) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "summary-header" }, [
                        _createElementVNode("span", { class: "dot inactive" }),
                        _createElementVNode("span", { class: "label" }, "퇴소")
                      ], -1)),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(beneficiaryStats.value.toiso) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, "당월입소 " + _toDisplayString(beneficiaryStats.value.monthEnter) + " · 당월퇴소 " + _toDisplayString(beneficiaryStats.value.monthLeave), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[92] || (_cache[92] = _createElementVNode("span", { class: "search-label" }, "수급자 검색", -1)),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((beneficiarySearchText).value = $event)),
                        type: "text",
                        placeholder: "이름, 인정번호...",
                        class: "search-input"
                      }, null, 512), [
                        [_vModelText, beneficiarySearchText.value]
                      ]),
                      (beneficiarySearchText.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "search-clear",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (beneficiarySearchText.value = ''))
                          }, [
                            _createVNode(_component_v_icon, { size: "10" }, {
                              default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 64))
          ]),
          _createVNode(LtcsRequestSidebarButton, {
            "member-code": memberCode.value,
            "biz-gubun": selectedBizGubun.value,
            "year-month": scheduleYearMonth.value,
            variant: "hr",
            onReady: loadAll
          }, null, 8, ["member-code", "biz-gubun", "year-month"])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              type: "button",
              role: "tab",
              class: _normalizeClass(["wage-hr-segment-btn wage-hr-segment-btn--employee", { active: activeTab.value === 'employee' }]),
              "aria-selected": activeTab.value === 'employee',
              onClick: _cache[12] || (_cache[12] = ($event: any) => (setActiveTab('employee')))
            }, [
              _createElementVNode("span", _hoisted_41, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                    _createTextVNode("mdi-account-hard-hat", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[94] || (_cache[94] = _createElementVNode("span", { class: "segment-text" }, [
                _createElementVNode("span", { class: "segment-label" }, "사원"),
                _createElementVNode("span", { class: "segment-desc" }, "종사자 · 직원")
              ], -1)),
              _createElementVNode("span", _hoisted_42, _toDisplayString(employeeStats.value.total), 1)
            ], 10, _hoisted_40),
            _createElementVNode("button", {
              type: "button",
              role: "tab",
              class: _normalizeClass(["wage-hr-segment-btn wage-hr-segment-btn--beneficiary", { active: activeTab.value === 'beneficiary' }]),
              "aria-selected": activeTab.value === 'beneficiary',
              onClick: _cache[13] || (_cache[13] = ($event: any) => (setActiveTab('beneficiary')))
            }, [
              _createElementVNode("span", _hoisted_44, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                    _createTextVNode("mdi-wheelchair-accessibility", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[96] || (_cache[96] = _createElementVNode("span", { class: "segment-text" }, [
                _createElementVNode("span", { class: "segment-label" }, "수급자"),
                _createElementVNode("span", { class: "segment-desc" }, "이용자 · 대상자")
              ], -1)),
              _createElementVNode("span", _hoisted_45, _toDisplayString(beneficiaryStats.value.total), 1)
            ], 10, _hoisted_43)
          ]),
          _createElementVNode("div", _hoisted_46, [
            (activeTab.value === 'employee')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["ben-quickadd-toggle", { active: showEmployeeQuickAdd.value }]),
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (showEmployeeQuickAdd.value = !showEmployeeQuickAdd.value))
                }, [
                  _createVNode(_component_v_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showEmployeeQuickAdd.value ? 'mdi-chevron-up' : 'mdi-account-plus-outline'), 1)
                    ]),
                    _: 1
                  }),
                  _cache[97] || (_cache[97] = _createTextVNode(" 간편등록 ", -1))
                ], 2))
              : _createCommentVNode("", true),
            (activeTab.value === 'beneficiary')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: _normalizeClass(["ben-quickadd-toggle", { active: showBeneficiaryQuickAdd.value }]),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (showBeneficiaryQuickAdd.value = !showBeneficiaryQuickAdd.value))
                }, [
                  _createVNode(_component_v_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showBeneficiaryQuickAdd.value ? 'mdi-chevron-up' : 'mdi-account-plus-outline'), 1)
                    ]),
                    _: 1
                  }),
                  _cache[98] || (_cache[98] = _createTextVNode(" 간편등록 ", -1))
                ], 2))
              : _createCommentVNode("", true),
            (activeTab.value === 'beneficiary')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "ben-excel-btn",
                  onClick: openBeneficiaryExcelModal
                }, [
                  _createVNode(_component_v_icon, { size: "15" }, {
                    default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                      _createTextVNode("mdi-file-excel-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[100] || (_cache[100] = _createTextVNode(" 엑셀 업로드 ", -1))
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'beneficiary')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "hr-toolbar-schedule-btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (showAllBeneficiarySchedule.value = true))
                  }, [
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                        _createTextVNode("mdi-calendar-month", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[102] || (_cache[102] = _createTextVNode(" 전체 일정 ", -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "hr-toolbar-schedule-btn hr-toolbar-schedule-btn--pdf",
                    disabled: beneficiaryPdfLoading.value,
                    onClick: downloadAllBeneficiaryPdf
                  }, [
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(beneficiaryPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                      ]),
                      _: 1
                    }),
                    _cache[103] || (_cache[103] = _createTextVNode(" 전체 PDF ", -1))
                  ], 8, _hoisted_47)
                ], 64))
              : _createCommentVNode("", true),
            (activeTab.value === 'employee')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  type: "button",
                  class: "hr-toolbar-schedule-btn hr-toolbar-schedule-btn--pdf",
                  disabled: employeePdfLoading.value,
                  onClick: downloadAllCaregiverPdf
                }, [
                  _createVNode(_component_v_icon, { size: "15" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(employeePdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                    ]),
                    _: 1
                  }),
                  _cache[104] || (_cache[104] = _createTextVNode(" 전체 PDF ", -1))
                ], 8, _hoisted_48))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_v_icon, {
                size: "16",
                color: "#1e3a5f"
              }, {
                default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                  _createTextVNode("mdi-cellphone-link", -1)
                ]))]),
                _: 1
              }),
              _cache[106] || (_cache[106] = _createElementVNode("div", { class: "hr-app-link-guide__body" }, [
                _createElementVNode("p", { class: "hr-app-link-guide__title" }, "카이온 앱 요양보호사 연결"),
                _createElementVNode("p", { class: "hr-app-link-guide__text" }, " 요양보호사 앱 계정은 여기서 만들지 않습니다. 성명·휴대폰을 사원으로 등록한 뒤, 같은 휴대폰으로 앱에 가입하면 연결됩니다. 앱에 이름이 없으면 동기화할 때 웹 사원 이름이 들어갑니다. 가입 후에도 센터 앱에 안 보이면 센터 앱 인사관리에서 「동기화」를 누르세요. 연동된 사원은 이름 옆에 「앱연동」이 표시됩니다. ")
              ], -1))
            ]),
            (employeeSsnMissingCount.value > 0 && employeeStatusFilter.value !== '주민번호미등록')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: "#e65100"
                  }, {
                    default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                      _createTextVNode("mdi-card-account-details-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("p", _hoisted_54, "주민번호가 없는 직원이 " + _toDisplayString(employeeSsnMissingCount.value) + "명 있어요", 1),
                    _cache[108] || (_cache[108] = _createElementVNode("p", { class: "hr-ssn-guide__text" }, " 자동수집 직원은 주민번호가 비어 있을 수 있습니다. 임금·4대보험 계산을 위해 상세에서 주민번호 뒷자리를 등록해 주세요. ", -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "hr-ssn-guide__btn",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (employeeStatusFilter.value = '주민번호미등록'))
                  }, " 미등록 목록 보기 ")
                ]))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "panel-slide" }, {
              default: _withCtx(() => [
                (showEmployeeQuickAdd.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newEmployeeRows.value, (row, rowIdx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row._key,
                          class: "quickadd-row"
                        }, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_58, [...(_cache[109] || (_cache[109] = [
                                    _createTextVNode("성명 ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.clci_name) = $event),
                                placeholder: "성명"
                              }, null, 8, _hoisted_59), [
                                [_vModelText, row.clci_name]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_61, [...(_cache[110] || (_cache[110] = [
                                    _createTextVNode("생년월일(8자리) ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _createElementVNode("input", {
                                value: row.clci_birth_ymd,
                                maxlength: "8",
                                inputmode: "numeric",
                                placeholder: "YYYYMMDD",
                                autocomplete: "off",
                                onInput: ($event: any) => (onEmployeeBirthYmdInput(row, $event))
                              }, null, 40, _hoisted_62)
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_64, [...(_cache[111] || (_cache[111] = [
                                    _createTextVNode("주민뒷자리 ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.clci_ssn_back) = $event),
                                maxlength: "7",
                                inputmode: "numeric",
                                placeholder: "7자리",
                                autocomplete: "off"
                              }, null, 8, _hoisted_65), [
                                [_vModelText, row.clci_ssn_back]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_67, [...(_cache[112] || (_cache[112] = [
                                    _createTextVNode("직종 ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((row.clci_job_type) = $event)
                              }, [
                                _cache[113] || (_cache[113] = _createElementVNode("option", { value: "" }, "선택", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(positionOptions), (pos) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: pos,
                                    value: pos
                                  }, _toDisplayString(pos), 9, _hoisted_69))
                                }), 128))
                              ], 8, _hoisted_68), [
                                [_vModelSelect, row.clci_job_type]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_71, [...(_cache[114] || (_cache[114] = [
                                    _createTextVNode("휴대폰 ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.clci_phone) = $event),
                                placeholder: "010-0000-0000"
                              }, null, 8, _hoisted_72), [
                                [_vModelText, row.clci_phone]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_74, "이메일"))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.clci_email) = $event),
                                type: "email",
                                placeholder: "선택"
                              }, null, 8, _hoisted_75), [
                                [_vModelText, row.clci_email]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_77, [...(_cache[115] || (_cache[115] = [
                                    _createTextVNode("입사일 ", -1),
                                    _createElementVNode("em", null, "*", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              _createVNode(YmdDateInput, {
                                modelValue: row.clci_work_start_date,
                                "onUpdate:modelValue": ($event: any) => ((row.clci_work_start_date) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              (rowIdx === 0)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_79, " "))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_80, [
                                (rowIdx === newEmployeeRows.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "qf-icon-btn qf-icon-btn--add",
                                      title: "행 추가",
                                      onClick: addEmployeeQuickRow
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                                          _createTextVNode("mdi-plus", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (newEmployeeRows.value.length > 1)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "qf-icon-btn qf-icon-btn--remove",
                                      title: "행 삭제",
                                      onClick: ($event: any) => (removeEmployeeQuickRow(rowIdx))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[117] || (_cache[117] = [
                                          _createTextVNode("mdi-minus", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_81))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("span", _hoisted_83, _toDisplayString(newEmployeeRows.value.length) + "명 · + 로 추가", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "qf-register-btn",
                          onClick: saveNewEmployee,
                          disabled: employeeSaving.value || !employeeQuickAddJoinReady.value,
                          title: employeeQuickAddJoinReady.value ? '' : '입사일을 입력해야 등록할 수 있습니다.'
                        }, [
                          (employeeSaving.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                size: "14",
                                width: "2",
                                color: "white"
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("일괄 등록")
                              ], 64))
                        ], 8, _hoisted_84)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("table", _hoisted_86, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[126] || (_cache[126] = _createElementVNode("th", null, "No", -1)),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (toggleEmployeeSort('clci_name')))
                    }, [
                      _cache[118] || (_cache[118] = _createTextVNode(" 성명 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_name')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (toggleEmployeeSort('clci_job_type')))
                    }, [
                      _cache[119] || (_cache[119] = _createTextVNode(" 직종 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_job_type')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (toggleEmployeeSort('clci_age')))
                    }, [
                      _cache[120] || (_cache[120] = _createTextVNode(" 만나이 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_age')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[127] || (_cache[127] = _createElementVNode("th", null, "주민등록번호", -1)),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (toggleEmployeeSort('clci_work_start_date')))
                    }, [
                      _cache[121] || (_cache[121] = _createTextVNode(" 입사일 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_work_start_date')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (toggleEmployeeSort('clci_work_end_date')))
                    }, [
                      _cache[122] || (_cache[122] = _createTextVNode(" 퇴사일 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_work_end_date')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (toggleEmployeeSort('month_status')))
                    }, [
                      _cache[123] || (_cache[123] = _createTextVNode(" 현황 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('month_status')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (toggleEmployeeSort('clci_source_label')))
                    }, [
                      _cache[124] || (_cache[124] = _createTextVNode(" 수집구분 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_source_label')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (toggleEmployeeSort('clci_wdate')))
                    }, [
                      _cache[125] || (_cache[125] = _createTextVNode(" 수집일시 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getEmployeeSortIcon('clci_wdate')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[128] || (_cache[128] = _createElementVNode("th", { class: "col-schedule" }, "일정", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (employeeLoading.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_87, [
                        _createElementVNode("td", _hoisted_88, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "primary",
                            size: "32"
                          })
                        ])
                      ]))
                    : (filteredEmployeeList.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_89, [
                          _createElementVNode("td", _hoisted_90, [
                            (employeeStatusFilter.value === '앱연동')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("앱과 연동된 사원이 없습니다.")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[129] || (_cache[129] = _createTextVNode(" 해당 연월에 표시할 사원이 없습니다. ", -1)),
                                  (!showEmployeeQuickAdd.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "hr-empty-add-btn",
                                        onClick: _cache[26] || (_cache[26] = ($event: any) => (showEmployeeQuickAdd.value = true))
                                      }, "간편등록"))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ])
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredEmployeeList.value, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.person_key || `${item.clci_source}-${item.clci_idx}`,
                            class: _normalizeClass(["row-clickable", { 'row-duplicate': item.is_duplicate }]),
                            onClick: ($event: any) => (openEmployeeDetail(item))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(idx + 1), 1),
                            _createElementVNode("td", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", {
                                  class: "avatar",
                                  style: _normalizeStyle({ background: getAvatarColor(item.clci_name) })
                                }, _toDisplayString(getInitial(item.clci_name)), 5),
                                _createElementVNode("span", _hoisted_94, [
                                  _createElementVNode("span", null, _toDisplayString(item.clci_name), 1),
                                  (isEmployeeAppLinked(item))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "app-link-badge",
                                        title: employeeAppLinkTitle(item)
                                      }, "앱연동", 8, _hoisted_95))
                                    : _createCommentVNode("", true)
                                ]),
                                (isEmployeeSsnMissing(item))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_96, "미등록"))
                                  : _createCommentVNode("", true),
                                (item.is_rehire || isEmployeeRehire(item))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_97, "재입사"))
                                  : _createCommentVNode("", true),
                                (item.is_month_enter)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_98, "당월입사"))
                                  : _createCommentVNode("", true),
                                (item.is_month_leave)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_99, "당월퇴사"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.clci_job_type || '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(item.clci_age != null ? `${item.clci_age}세` : '-'), 1),
                            _createElementVNode("td", _hoisted_100, [
                              (formatSsnFront(item.clci_birth_date) !== '******')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", _hoisted_101, _toDisplayString(formatSsnFront(item.clci_birth_date)) + "-", 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["emp-ssn-line", isEmployeeSsnMissing(item) ? 'emp-ssn-line--missing' : 'emp-ssn-line--mask'])
                                    }, _toDisplayString(isEmployeeSsnMissing(item) ? '미등록' : '*******'), 3)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("-")
                                  ], 64))
                            ]),
                            _createElementVNode("td", {
                              class: "td-join",
                              title: joinDateHint(item)
                            }, [
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("span", _hoisted_104, _toDisplayString(formatDate(shownEmployment(item)?.clci_work_start_date)), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherJoinLines(item), (line) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: `${line.clci_source}-${line.clci_idx}-start`,
                                    class: "emp-join__sub"
                                  }, _toDisplayString(otherJoinCaption(item, line)), 1))
                                }), 128))
                              ])
                            ], 8, _hoisted_102),
                            _createElementVNode("td", null, _toDisplayString(formatDate(shownEmployment(item)?.clci_work_end_date)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["status-chip", item.month_status === '현원' ? 'active' : 'inactive'])
                              }, _toDisplayString(item.month_status), 3)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["source-chip", shownEmployment(item)?.clci_source === 'manual' ? 'manual' : 'auto'])
                              }, _toDisplayString(employmentSourceLabel(shownEmployment(item)?.clci_source)), 3)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(formatDateTime(latestCollectAt(item))), 1),
                            _createElementVNode("td", _hoisted_105, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "hr-schedule-btn",
                                disabled: !canOpenEmployeeSchedule(item),
                                title: canOpenEmployeeSchedule(item) ? '월간 일정 보기' : '생년월일이 있어야 일정을 조회할 수 있습니다',
                                onClick: _withModifiers(($event: any) => (openEmployeeSchedule(item)), ["stop"])
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                                    _createTextVNode("mdi-calendar-clock", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_106)
                            ])
                          ], 10, _hoisted_91))
                        }), 128))
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, activeTab.value === 'employee']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_Transition, { name: "panel-slide" }, {
              default: _withCtx(() => [
                (showBeneficiaryQuickAdd.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _cache[131] || (_cache[131] = _createElementVNode("label", null, [
                            _createTextVNode("수급자명 "),
                            _createElementVNode("em", null, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((newBeneficiaryForm.value.clsr_recipient_name) = $event)),
                            placeholder: "수급자명"
                          }, null, 512), [
                            [_vModelText, newBeneficiaryForm.value.clsr_recipient_name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _cache[132] || (_cache[132] = _createElementVNode("label", null, "인정번호", -1)),
                          _createElementVNode("input", {
                            value: newBeneficiaryForm.value.clsr_approval_no || '',
                            placeholder: "L0000000000",
                            maxlength: "11",
                            onFocus: onRecipientIdFocus,
                            onBlur: onRecipientIdBlur,
                            onInput: onRecipientIdInput,
                            class: _normalizeClass({ 'input-error': newBeneficiaryForm.value.clsr_approval_no && !isValidRecipientId(newBeneficiaryForm.value.clsr_approval_no) })
                          }, null, 42, _hoisted_113)
                        ]),
                        _createElementVNode("div", _hoisted_114, [
                          _cache[133] || (_cache[133] = _createElementVNode("label", null, [
                            _createTextVNode("생년월일 "),
                            _createElementVNode("em", null, "*")
                          ], -1)),
                          _createVNode(YmdDateInput, {
                            modelValue: newBeneficiaryForm.value.clsr_birth_date,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((newBeneficiaryForm.value.clsr_birth_date) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_115, [
                          _cache[134] || (_cache[134] = _createElementVNode("label", null, "급여종류", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((newBeneficiaryForm.value.clsr_service_type) = $event)),
                            placeholder: "방문요양 등"
                          }, null, 512), [
                            [_vModelText, newBeneficiaryForm.value.clsr_service_type]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _cache[135] || (_cache[135] = _createElementVNode("label", null, "입소일", -1)),
                          _createVNode(YmdDateInput, {
                            modelValue: newBeneficiaryForm.value.clsr_enter_date,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((newBeneficiaryForm.value.clsr_enter_date) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _cache[136] || (_cache[136] = _createElementVNode("label", null, "연락처", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((newBeneficiaryForm.value.clsr_phone) = $event)),
                            placeholder: "연락처"
                          }, null, 512), [
                            [_vModelText, newBeneficiaryForm.value.clsr_phone]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _cache[137] || (_cache[137] = _createElementVNode("label", null, " ", -1)),
                          _createElementVNode("input", {
                            placeholder: "Enter로 등록",
                            onKeydown: _withKeys(_withModifiers(saveNewBeneficiary, ["prevent"]), ["enter"])
                          }, null, 40, _hoisted_119)
                        ]),
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "qf-register-btn",
                            onClick: saveNewBeneficiary,
                            disabled: !canSaveNew.value || beneficiarySaving.value
                          }, [
                            (beneficiarySaving.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  color: "white"
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("등록")
                                ], 64))
                          ], 8, _hoisted_121)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("table", _hoisted_123, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[144] || (_cache[144] = _createElementVNode("th", null, "No", -1)),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (toggleBeneficiarySort('clsr_recipient_name')))
                    }, [
                      _cache[138] || (_cache[138] = _createTextVNode(" 수급자명 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('clsr_recipient_name')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (toggleBeneficiarySort('clsr_grade')))
                    }, [
                      _cache[139] || (_cache[139] = _createTextVNode(" 등급 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('clsr_grade')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[145] || (_cache[145] = _createElementVNode("th", null, "주민등록번호", -1)),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (toggleBeneficiarySort('clsr_service_type')))
                    }, [
                      _cache[140] || (_cache[140] = _createTextVNode(" 급여종류 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('clsr_service_type')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (toggleBeneficiarySort('clsr_approval_no')))
                    }, [
                      _cache[141] || (_cache[141] = _createTextVNode(" 인정번호 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('clsr_approval_no')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (toggleBeneficiarySort('month_status')))
                    }, [
                      _cache[142] || (_cache[142] = _createTextVNode(" 현황 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('month_status')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("th", {
                      class: "sortable",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (toggleBeneficiarySort('clsr_source_label')))
                    }, [
                      _cache[143] || (_cache[143] = _createTextVNode(" 수집구분 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getBeneficiarySortIcon('clsr_source_label')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[146] || (_cache[146] = _createElementVNode("th", { class: "col-schedule" }, "일정", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (beneficiaryLoading.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_124, [
                        _createElementVNode("td", _hoisted_125, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "primary",
                            size: "32"
                          })
                        ])
                      ]))
                    : (filteredBeneficiaryList.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_126, [
                          _createElementVNode("td", _hoisted_127, [
                            _cache[147] || (_cache[147] = _createTextVNode(" 해당 연월에 표시할 수급자가 없습니다. ", -1)),
                            (!showBeneficiaryQuickAdd.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "hr-empty-add-btn",
                                  onClick: _cache[38] || (_cache[38] = ($event: any) => (showBeneficiaryQuickAdd.value = true))
                                }, "간편등록"))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredBeneficiaryList.value, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `${item.clsr_source}-${item.clsr_idx}`,
                            class: "row-clickable",
                            onClick: ($event: any) => (openBeneficiaryDetail(item))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(idx + 1), 1),
                            _createElementVNode("td", _hoisted_129, [
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("div", {
                                  class: "avatar",
                                  style: _normalizeStyle({ background: getAvatarColor(item.clsr_recipient_name) })
                                }, _toDisplayString(getInitial(item.clsr_recipient_name)), 5),
                                _createElementVNode("span", null, _toDisplayString(item.clsr_recipient_name), 1),
                                (isBeneficiaryReenter(item))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_131, "재입소"))
                                  : _createCommentVNode("", true),
                                (item.is_month_enter)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_132, "당월입소"))
                                  : _createCommentVNode("", true),
                                (item.is_month_leave)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_133, "당월퇴소"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.clsr_grade || '-'), 1),
                            _createElementVNode("td", _hoisted_134, [
                              (beneficiarySsnFront(item) !== '******')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", _hoisted_135, _toDisplayString(beneficiarySsnFront(item)) + "-", 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["emp-ssn-line", isBeneficiarySsnMissing(item) ? 'emp-ssn-line--missing' : 'emp-ssn-line--mask'])
                                    }, _toDisplayString(isBeneficiarySsnMissing(item) ? '미등록' : '*******'), 3)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("-")
                                  ], 64))
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.clsr_service_type || '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(item.clsr_approval_no || '-'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["status-chip", item.month_status === '입소' ? 'active' : 'inactive'])
                              }, _toDisplayString(item.month_status), 3)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["source-chip", item.clsr_source === 'auto' ? 'auto' : 'manual'])
                              }, _toDisplayString(item.clsr_source_label), 3)
                            ]),
                            _createElementVNode("td", _hoisted_136, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "hr-schedule-btn",
                                disabled: !canOpenBeneficiarySchedule(item),
                                title: canOpenBeneficiarySchedule(item) ? '월간 일정 보기' : '인정번호가 있어야 일정을 조회할 수 있습니다',
                                onClick: _withModifiers(($event: any) => (openBeneficiarySchedule(item)), ["stop"])
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[148] || (_cache[148] = [
                                    _createTextVNode("mdi-calendar-clock", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_137)
                            ])
                          ], 8, _hoisted_128))
                        }), 128))
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, activeTab.value === 'beneficiary']
        ])
      ])
    ]),
    _createVNode(BeneficiaryCalendarModal, {
      modelValue: showBeneficiaryCalendar.value,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((showBeneficiaryCalendar).value = $event)),
      beneficiary: calendarBeneficiary.value,
      beneficiaries: calendarBeneficiaryList.value,
      "member-code": memberCode.value,
      "biz-gubun": selectedBizGubun.value,
      year: selectedYear.value,
      month: selectedMonth.value
    }, null, 8, ["modelValue", "beneficiary", "beneficiaries", "member-code", "biz-gubun", "year", "month"]),
    _createVNode(ScheduleCalendarModal, {
      modelValue: showEmployeeCalendar.value,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((showEmployeeCalendar).value = $event)),
      caregiver: calendarCaregiver.value,
      caregivers: calendarCaregiverList.value,
      "member-code": memberCode.value,
      "biz-gubun": selectedBizGubun.value,
      year: selectedYear.value,
      month: selectedMonth.value
    }, null, 8, ["modelValue", "caregiver", "caregivers", "member-code", "biz-gubun", "year", "month"]),
    _createVNode(BeneficiaryAllScheduleModal, {
      modelValue: showAllBeneficiarySchedule.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((showAllBeneficiarySchedule).value = $event)),
      "member-code": memberCode.value,
      "biz-gubun": selectedBizGubun.value,
      year: selectedYear.value,
      month: selectedMonth.value,
      onOpenRecipient: onOpenRecipientFromAllSchedule
    }, null, 8, ["modelValue", "member-code", "biz-gubun", "year", "month"]),
    _createVNode(_component_v_dialog, {
      modelValue: employeeDetailDialog.value,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((employeeDetailDialog).value = $event)),
      "max-width": "560",
      persistent: "",
      "content-class": "hr-detail-dialog-shell"
    }, {
      default: _withCtx(() => [
        (selectedEmployee.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
              _createElementVNode("header", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", {
                    class: "hr-detail-modal__avatar",
                    style: _normalizeStyle({ background: getAvatarColor(selectedEmployee.value.clci_name) })
                  }, _toDisplayString(getInitial(selectedEmployee.value.clci_name)), 5),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("h3", null, _toDisplayString(selectedEmployee.value.clci_name), 1),
                    _createElementVNode("span", _hoisted_142, _toDisplayString(selectedEmployee.value.clci_job_type || '직종 미등록'), 1),
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["hr-detail-modal__chip hr-detail-modal__chip--source", selectedEmployee.value.clci_source])
                      }, _toDisplayString(selectedEmployee.value.clci_source_label), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["hr-detail-modal__chip hr-detail-modal__chip--status", selectedEmployee.value.month_status === '현원' ? 'is-active' : 'is-inactive'])
                      }, _toDisplayString(selectedEmployee.value.month_status), 3),
                      (isEmployeeAppLinked(selectedEmployee.value))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "hr-detail-modal__chip hr-detail-modal__chip--app",
                            title: employeeAppLinkTitle(selectedEmployee.value)
                          }, " 앱연동" + _toDisplayString(selectedEmployee.value.app_link_label ? ` · ${selectedEmployee.value.app_link_label}` : ''), 9, _hoisted_144))
                        : _createCommentVNode("", true),
                      (selectedEmployee.value.is_month_enter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_145, "당월입사"))
                        : _createCommentVNode("", true),
                      (selectedEmployee.value.is_month_leave)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_146, "당월퇴사"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "hr-detail-modal__close",
                  "aria-label": "닫기",
                  onClick: closeEmployeeDetail
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_147, [
                (isEmployeeAppLinked(selectedEmployee.value))
                  ? (_openBlock(), _createBlock(EmployeeProfileLinkPanel, {
                      key: 0,
                      "m-code": String(memberCode.value),
                      source: selectedEmployee.value.clci_source === 'manual' ? 'manual' : 'auto',
                      "clci-idx": Number(selectedEmployee.value.clci_idx),
                      onApplied: onEmployeeProfileLinked
                    }, null, 8, ["m-code", "source", "clci-idx"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_148, [
                  _cache[167] || (_cache[167] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "기본 정보", -1)),
                  _createElementVNode("div", _hoisted_149, [
                    _cache[150] || (_cache[150] = _createElementVNode("label", null, "성명", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((employeeEditForm.value.clci_name) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, employeeEditForm.value.clci_name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _cache[151] || (_cache[151] = _createElementVNode("label", null, [
                      _createTextVNode("생년월일(8자리) "),
                      _createElementVNode("em", null, "*")
                    ], -1)),
                    _createElementVNode("input", {
                      class: "hr-birth-ymd-input",
                      value: employeeEditForm.value.clci_birth_ymd,
                      type: "text",
                      maxlength: "8",
                      inputmode: "numeric",
                      autocomplete: "off",
                      placeholder: "YYYYMMDD",
                      onInput: _cache[43] || (_cache[43] = ($event: any) => (onEmployeeBirthYmdInput(employeeEditForm.value, $event)))
                    }, null, 40, _hoisted_151)
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("label", _hoisted_153, [
                      _cache[152] || (_cache[152] = _createTextVNode(" 주민등록번호 ", -1)),
                      (selectedEmployee.value.clci_has_ssn_back)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_154, "뒷자리 등록됨"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_155, "뒷자리 없음"))
                    ]),
                    (selectedEmployee.value && isEmployeeSsnMissing(selectedEmployee.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                          _createVNode(_component_v_icon, {
                            size: "15",
                            color: "#e65100"
                          }, {
                            default: _withCtx(() => [...(_cache[153] || (_cache[153] = [
                              _createTextVNode("mdi-alert-circle-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[154] || (_cache[154] = _createElementVNode("div", { class: "hr-ssn-guide__body" }, [
                            _createElementVNode("p", { class: "hr-ssn-guide__title" }, "주민번호가 등록되지 않았습니다"),
                            _createElementVNode("p", { class: "hr-ssn-guide__text" }, "아래 뒷자리 7자리를 입력한 뒤 저장해 주세요. 임금·4대보험 계산에 필요합니다.")
                          ], -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("span", _hoisted_158, _toDisplayString(formatSsnFront(employeeEditForm.value.clci_birth_date)), 1),
                      _cache[156] || (_cache[156] = _createElementVNode("span", { class: "hr-ssn-dash" }, "-", -1)),
                      (selectedEmployee.value.clci_has_ssn_back && !employeeSsnEditing.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["hr-ssn-back-mask", { 'is-revealed': ssnRevealed.value && ssnRevealedValue.value }])
                          }, _toDisplayString(ssnRevealed.value && ssnRevealedValue.value ? ssnRevealedValue.value : '●●●●●●●'), 3))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((employeeEditForm.value.clci_ssn_back) = $event)),
                            class: "hr-ssn-back-input",
                            type: "text",
                            maxlength: "7",
                            inputmode: "numeric",
                            autocomplete: "off",
                            placeholder: selectedEmployee.value.clci_has_ssn_back ? '새 뒷자리 7자리' : '뒷자리 7자리'
                          }, null, 8, _hoisted_159)), [
                            [_vModelText, employeeEditForm.value.clci_ssn_back]
                          ]),
                      (selectedEmployee.value.clci_has_ssn_back && !employeeSsnEditing.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "hr-ssn-reveal-btn",
                            disabled: ssnRevealing.value,
                            onClick: revealEmployeeSsn
                          }, [
                            (ssnRevealing.value)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  size: "14",
                                  class: "mdi-spin"
                                }, {
                                  default: _withCtx(() => [...(_cache[155] || (_cache[155] = [
                                    _createTextVNode("mdi-loading", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(ssnRevealed.value ? '숨기기' : '보기'), 1)
                                ], 64))
                          ], 8, _hoisted_160))
                        : _createCommentVNode("", true),
                      (selectedEmployee.value.clci_has_ssn_back && !employeeSsnEditing.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "hr-ssn-reveal-btn",
                            onClick: startEmployeeSsnEdit
                          }, "변경"))
                        : _createCommentVNode("", true),
                      (selectedEmployee.value.clci_has_ssn_back && employeeSsnEditing.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            class: "hr-ssn-reveal-btn",
                            onClick: cancelEmployeeSsnEdit
                          }, "취소"))
                        : _createCommentVNode("", true)
                    ]),
                    (selectedEmployee.value.clci_has_ssn_back && !employeeSsnEditing.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_161, "뒷자리 7자리가 저장되어 있습니다. 숫자를 바꿀 때만 변경을 누르세요."))
                      : (selectedEmployee.value.clci_has_ssn_back)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_162, "새 뒷자리를 입력한 뒤 저장하면 바뀝니다. 비워 두면 기존 값이 유지됩니다."))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_163, [
                    _cache[158] || (_cache[158] = _createElementVNode("label", null, "직종", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((employeeEditForm.value.clci_job_type) = $event))
                    }, [
                      _cache[157] || (_cache[157] = _createElementVNode("option", { value: "" }, "선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(positionOptions), (pos) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: pos,
                          value: pos
                        }, _toDisplayString(pos), 9, _hoisted_164))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, employeeEditForm.value.clci_job_type]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _cache[159] || (_cache[159] = _createElementVNode("label", null, "연락처", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((employeeEditForm.value.clci_phone) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, employeeEditForm.value.clci_phone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_166, [
                    _cache[160] || (_cache[160] = _createElementVNode("label", null, "이메일", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((employeeEditForm.value.clci_email) = $event)),
                      type: "email"
                    }, null, 512), [
                      [_vModelText, employeeEditForm.value.clci_email]
                    ])
                  ]),
                  _cache[168] || (_cache[168] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "근무 정보", -1)),
                  (employmentLines(selectedEmployee.value).length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employmentLines(selectedEmployee.value), (line) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `${line.clci_source}-${line.clci_idx}-detail`,
                              class: _normalizeClass(["hr-employment-line", { 'is-applied': isWageEmployment(selectedEmployee.value, line) }])
                            }, [
                              _createElementVNode("span", _hoisted_169, _toDisplayString(line.clci_source_label), 1),
                              _createElementVNode("span", _hoisted_170, _toDisplayString(formatDate(line.clci_work_start_date)), 1),
                              _createElementVNode("span", _hoisted_171, _toDisplayString(leaveDateOf(line) ? formatDate(line.clci_work_end_date) : '재직'), 1)
                            ], 2))
                          }), 128))
                        ]),
                        _createElementVNode("p", _hoisted_172, _toDisplayString(wageEmploymentNote(selectedEmployee.value)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("label", null, [
                      _cache[161] || (_cache[161] = _createTextVNode(" 입사일 ", -1)),
                      _cache[162] || (_cache[162] = _createElementVNode("em", null, "*", -1)),
                      (hasSeveralEmployments(selectedEmployee.value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_174, _toDisplayString(employmentSourceLabel(selectedEmployee.value.clci_source)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(YmdDateInput, {
                      modelValue: employeeEditForm.value.clci_work_start_date,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((employeeEditForm.value.clci_work_start_date) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("label", null, [
                      _cache[163] || (_cache[163] = _createTextVNode(" 퇴사일 ", -1)),
                      (hasSeveralEmployments(selectedEmployee.value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_176, _toDisplayString(employmentSourceLabel(selectedEmployee.value.clci_source)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(YmdDateInput, {
                      modelValue: employeeEditForm.value.clci_work_end_date,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((employeeEditForm.value.clci_work_end_date) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[169] || (_cache[169] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "주소", -1)),
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("input", {
                        value: employeeEditForm.value.clci_zipcode,
                        class: "hr-addr-zip",
                        type: "text",
                        readonly: "",
                        placeholder: "우편번호",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (openPostcode('employee')))
                      }, null, 8, _hoisted_179),
                      _createElementVNode("button", {
                        type: "button",
                        class: "hr-addr-search-btn",
                        onClick: _cache[51] || (_cache[51] = ($event: any) => (openPostcode('employee')))
                      }, [
                        _createVNode(_component_v_icon, { size: "15" }, {
                          default: _withCtx(() => [...(_cache[164] || (_cache[164] = [
                            _createTextVNode("mdi-map-search-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[165] || (_cache[165] = _createTextVNode(" 주소 찾기 ", -1))
                      ])
                    ]),
                    _createElementVNode("input", {
                      value: employeeEditForm.value.clci_addr1,
                      class: "hr-addr1",
                      type: "text",
                      readonly: "",
                      placeholder: "기본 주소 (주소 찾기로 선택하세요)",
                      onClick: _cache[52] || (_cache[52] = ($event: any) => (openPostcode('employee')))
                    }, null, 8, _hoisted_180),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((employeeEditForm.value.clci_addr2) = $event)),
                      type: "text",
                      placeholder: "상세 주소 (동·호수 등)",
                      maxlength: "100"
                    }, null, 512), [
                      [_vModelText, employeeEditForm.value.clci_addr2]
                    ])
                  ]),
                  (selectedEmployee.value.clci_wdate || selectedEmployee.value.clci_rdate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_181, "수집 정보"))
                    : _createCommentVNode("", true),
                  (selectedEmployee.value.clci_wdate || selectedEmployee.value.clci_rdate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                        _cache[166] || (_cache[166] = _createElementVNode("label", null, "수집일시", -1)),
                        _createElementVNode("input", {
                          value: formatDateTime(selectedEmployee.value.clci_wdate || selectedEmployee.value.clci_rdate),
                          type: "text",
                          readonly: ""
                        }, null, 8, _hoisted_183)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("footer", _hoisted_184, [
                (selectedEmployee.value.clci_source === 'manual')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "flat",
                      class: "btn-delete",
                      loading: employeeDeleting.value,
                      onClick: deleteEmployee
                    }, {
                      default: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                        _createTextVNode("삭제", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-confirm",
                  disabled: !canOpenEmployeeSchedule(selectedEmployee.value),
                  onClick: openEmployeeScheduleFromDetail
                }, {
                  default: _withCtx(() => [...(_cache[171] || (_cache[171] = [
                    _createTextVNode("월간 일정", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: closeEmployeeDetail
                }, {
                  default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  loading: employeeSaving.value,
                  disabled: !employeeEditForm.value.clci_work_start_date,
                  title: employeeEditForm.value.clci_work_start_date ? undefined : '입사일을 입력해야 저장할 수 있습니다.',
                  onClick: saveEmployeeEdit
                }, {
                  default: _withCtx(() => [...(_cache[173] || (_cache[173] = [
                    _createTextVNode("저장", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "title"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: beneficiaryDetailDialog.value,
      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((beneficiaryDetailDialog).value = $event)),
      "max-width": "680",
      persistent: "",
      "content-class": "hr-detail-dialog-shell"
    }, {
      default: _withCtx(() => [
        (selectedBeneficiary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
              _createElementVNode("header", _hoisted_186, [
                _createElementVNode("div", _hoisted_187, [
                  _createElementVNode("div", {
                    class: "hr-detail-modal__avatar",
                    style: _normalizeStyle({ background: getAvatarColor(selectedBeneficiary.value.clsr_recipient_name) })
                  }, _toDisplayString(getInitial(selectedBeneficiary.value.clsr_recipient_name)), 5),
                  _createElementVNode("div", _hoisted_188, [
                    _createElementVNode("h3", null, _toDisplayString(selectedBeneficiary.value.clsr_recipient_name), 1),
                    _createElementVNode("span", _hoisted_189, _toDisplayString(selectedBeneficiary.value.clsr_service_type || '급여종류 미등록'), 1),
                    _createElementVNode("div", _hoisted_190, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["hr-detail-modal__chip hr-detail-modal__chip--source", selectedBeneficiary.value.clsr_source])
                      }, _toDisplayString(selectedBeneficiary.value.clsr_source_label), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass(["hr-detail-modal__chip hr-detail-modal__chip--status", selectedBeneficiary.value.month_status === '입소' ? 'is-active' : 'is-inactive'])
                      }, _toDisplayString(selectedBeneficiary.value.month_status), 3),
                      (selectedBeneficiary.value.is_month_enter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_191, "당월입소"))
                        : _createCommentVNode("", true),
                      (selectedBeneficiary.value.is_month_leave)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_192, "당월퇴소"))
                        : _createCommentVNode("", true),
                      (isBeneficiaryReenter(selectedBeneficiary.value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_193, "재입소"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "hr-detail-modal__close",
                  "aria-label": "닫기",
                  onClick: closeBeneficiaryDetail
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[174] || (_cache[174] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_194, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["hr-detail-modal__tab", { 'is-active': beneficiaryDetailTab.value === 'info' }]),
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (beneficiaryDetailTab.value = 'info'))
                }, "정보", 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["hr-detail-modal__tab", { 'is-active': beneficiaryDetailTab.value === 'history' }]),
                  onClick: _cache[56] || (_cache[56] = ($event: any) => (beneficiaryDetailTab.value = 'history'))
                }, "이력", 2)
              ]),
              _createElementVNode("div", _hoisted_195, [
                (beneficiaryDetailTab.value === 'history')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                      (beneficiaryHistoryLoading.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_197, "이력을 불러오는 중..."))
                        : (beneficiaryHistory.value.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_198, " 아직 이력이 없습니다. 등급을 바꾸면 여기에 남습니다. "))
                          : (_openBlock(), _createElementBlock("ul", _hoisted_199, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beneficiaryHistory.value, (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: item.clrh_idx,
                                  class: "recipient-history-item"
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["recipient-history-item__dot", item.clrh_kind === 'grade' ? 'is-grade' : 'is-stay'])
                                  }, null, 2),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("strong", null, _toDisplayString(historyItemTitle(item)), 1),
                                    _createElementVNode("span", null, _toDisplayString(historyItemMeta(item)), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_200, [
                      _cache[194] || (_cache[194] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "기본 정보", -1)),
                      _createElementVNode("div", _hoisted_201, [
                        _cache[175] || (_cache[175] = _createElementVNode("label", null, "수급자명", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((beneficiaryEditForm.value.clsr_recipient_name) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_recipient_name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_202, [
                        _cache[176] || (_cache[176] = _createElementVNode("label", null, "생년월일", -1)),
                        _createVNode(YmdDateInput, {
                          modelValue: beneficiaryEditForm.value.clsr_birth_date,
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((beneficiaryEditForm.value.clsr_birth_date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_203, [
                        _createElementVNode("label", _hoisted_204, [
                          _cache[177] || (_cache[177] = _createTextVNode(" 주민등록번호 ", -1)),
                          (selectedBeneficiary.value.clsr_has_ssn_back)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_205, "뒷자리 등록됨"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_206, "뒷자리 없음"))
                        ]),
                        _createElementVNode("div", _hoisted_207, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((beneficiaryEditForm.value.clsr_ssn_front) = $event)),
                            class: "hr-ssn-front-input",
                            type: "text",
                            maxlength: "6",
                            inputmode: "numeric",
                            autocomplete: "off",
                            placeholder: "앞자리 6자리"
                          }, null, 512), [
                            [_vModelText, beneficiaryEditForm.value.clsr_ssn_front]
                          ]),
                          _cache[179] || (_cache[179] = _createElementVNode("span", { class: "hr-ssn-dash" }, "-", -1)),
                          (selectedBeneficiary.value.clsr_has_ssn_back && !beneficiarySsnEditing.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["hr-ssn-back-mask", { 'is-revealed': benSsnRevealed.value && benSsnRevealedValue.value }])
                              }, _toDisplayString(benSsnRevealed.value && benSsnRevealedValue.value ? benSsnRevealedValue.value : '●●●●●●●'), 3))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((beneficiaryEditForm.value.clsr_ssn_back) = $event)),
                                class: "hr-ssn-back-input",
                                type: "text",
                                maxlength: "7",
                                inputmode: "numeric",
                                autocomplete: "off",
                                placeholder: selectedBeneficiary.value.clsr_has_ssn_back ? '새 뒷자리 7자리' : '뒷자리 7자리'
                              }, null, 8, _hoisted_208)), [
                                [_vModelText, beneficiaryEditForm.value.clsr_ssn_back]
                              ]),
                          (selectedBeneficiary.value.clsr_has_ssn_back && !beneficiarySsnEditing.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "hr-ssn-reveal-btn",
                                disabled: benSsnRevealing.value,
                                onClick: revealBeneficiarySsn
                              }, [
                                (benSsnRevealing.value)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "14",
                                      class: "mdi-spin"
                                    }, {
                                      default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                                        _createTextVNode("mdi-loading", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(benSsnRevealed.value ? '숨기기' : '보기'), 1)
                                    ], 64))
                              ], 8, _hoisted_209))
                            : _createCommentVNode("", true),
                          (selectedBeneficiary.value.clsr_has_ssn_back && !beneficiarySsnEditing.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "hr-ssn-reveal-btn",
                                onClick: startBeneficiarySsnEdit
                              }, "변경"))
                            : _createCommentVNode("", true),
                          (selectedBeneficiary.value.clsr_has_ssn_back && beneficiarySsnEditing.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                type: "button",
                                class: "hr-ssn-reveal-btn",
                                onClick: cancelBeneficiarySsnEdit
                              }, "취소"))
                            : _createCommentVNode("", true)
                        ]),
                        (selectedBeneficiary.value.clsr_has_ssn_back && !beneficiarySsnEditing.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_210, "뒷자리 7자리가 저장되어 있습니다. 숫자를 바꿀 때만 변경을 누르세요."))
                          : (selectedBeneficiary.value.clsr_has_ssn_back)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_211, "새 뒷자리를 입력한 뒤 저장하면 바뀝니다. 비워 두면 기존 값이 유지됩니다."))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_212, [
                        _cache[180] || (_cache[180] = _createElementVNode("label", null, "인정번호", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((beneficiaryEditForm.value.clsr_approval_no) = $event)),
                          type: "text",
                          placeholder: "L0000000000",
                          maxlength: "11"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_approval_no]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_213, [
                        _cache[181] || (_cache[181] = _createElementVNode("label", null, "등급", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((beneficiaryEditForm.value.clsr_grade) = $event)),
                          type: "text",
                          placeholder: "예: 4등급"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_grade]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_214, [
                        _cache[182] || (_cache[182] = _createElementVNode("label", null, "급여종류", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((beneficiaryEditForm.value.clsr_service_type) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_service_type]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_215, [
                        _cache[183] || (_cache[183] = _createElementVNode("label", null, "연락처", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((beneficiaryEditForm.value.clsr_phone) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_phone]
                        ])
                      ]),
                      _cache[195] || (_cache[195] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "이용 정보", -1)),
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["recipient-stay-now", beneficiaryHasLeft.value ? 'is-left' : 'is-in'])
                        }, [
                          _cache[184] || (_cache[184] = _createElementVNode("span", { class: "recipient-stay-now__mark" }, null, -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(beneficiaryStayHeadline.value), 1),
                            _createElementVNode("p", null, _toDisplayString(beneficiaryStayDetail.value), 1)
                          ])
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_217, [
                        _cache[185] || (_cache[185] = _createElementVNode("label", null, "입소일", -1)),
                        _createVNode(YmdDateInput, {
                          modelValue: beneficiaryEditForm.value.clsr_enter_date,
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((beneficiaryEditForm.value.clsr_enter_date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_218, [
                        _cache[186] || (_cache[186] = _createElementVNode("label", null, "퇴소일", -1)),
                        _createVNode(YmdDateInput, {
                          modelValue: beneficiaryEditForm.value.clsr_leave_date,
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((beneficiaryEditForm.value.clsr_leave_date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      (!beneficiarySavedLeave.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                            _cache[187] || (_cache[187] = _createElementVNode("div", { class: "recipient-stay-action__title" }, "퇴소 처리", -1)),
                            _cache[188] || (_cache[188] = _createElementVNode("p", null, "이번 이용을 끝냅니다. 입소일과 등급은 그대로 둡니다.", -1)),
                            _createElementVNode("div", _hoisted_220, [
                              _createVNode(YmdDateInput, {
                                modelValue: stayLeaveDate.value,
                                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((stayLeaveDate).value = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "recipient-stay-action__btn",
                                disabled: beneficiaryStayActing.value,
                                onClick: recordBeneficiaryLeave
                              }, " 퇴소로 기록 ", 8, _hoisted_221)
                            ])
                          ]))
                        : (beneficiaryHasLeft.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                              _cache[189] || (_cache[189] = _createElementVNode("div", { class: "recipient-stay-action__title" }, "다시 입소", -1)),
                              _cache[190] || (_cache[190] = _createElementVNode("p", null, "지난 이용은 이력에 남고, 퇴소일은 비워집니다. 등급이 바뀌었으면 여기서 같이 고칩니다.", -1)),
                              _createElementVNode("div", _hoisted_223, [
                                _createVNode(YmdDateInput, {
                                  modelValue: reenterDate.value,
                                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((reenterDate).value = $event))
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((reenterGrade).value = $event)),
                                  type: "text",
                                  placeholder: "등급"
                                }, null, 512), [
                                  [_vModelText, reenterGrade.value]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "recipient-stay-action__btn",
                                  disabled: beneficiaryStayActing.value,
                                  onClick: recordBeneficiaryReenter
                                }, " 다시 입소로 기록 ", 8, _hoisted_224)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      _cache[196] || (_cache[196] = _createElementVNode("div", { class: "hr-detail-modal__section" }, "주소", -1)),
                      _createElementVNode("div", _hoisted_225, [
                        _createElementVNode("div", _hoisted_226, [
                          _createElementVNode("input", {
                            value: beneficiaryEditForm.value.clsr_zipcode,
                            class: "hr-addr-zip",
                            type: "text",
                            readonly: "",
                            placeholder: "우편번호",
                            onClick: _cache[70] || (_cache[70] = ($event: any) => (openPostcode('beneficiary')))
                          }, null, 8, _hoisted_227),
                          _createElementVNode("button", {
                            type: "button",
                            class: "hr-addr-search-btn",
                            onClick: _cache[71] || (_cache[71] = ($event: any) => (openPostcode('beneficiary')))
                          }, [
                            _createVNode(_component_v_icon, { size: "15" }, {
                              default: _withCtx(() => [...(_cache[191] || (_cache[191] = [
                                _createTextVNode("mdi-map-search-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[192] || (_cache[192] = _createTextVNode(" 주소 찾기 ", -1))
                          ])
                        ]),
                        _createElementVNode("input", {
                          value: beneficiaryEditForm.value.clsr_addr1,
                          class: "hr-addr1",
                          type: "text",
                          readonly: "",
                          placeholder: "기본 주소 (주소 찾기로 선택하세요)",
                          onClick: _cache[72] || (_cache[72] = ($event: any) => (openPostcode('beneficiary')))
                        }, null, 8, _hoisted_228),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((beneficiaryEditForm.value.clsr_addr2) = $event)),
                          type: "text",
                          placeholder: "상세 주소 (동·호수 등)",
                          maxlength: "100"
                        }, null, 512), [
                          [_vModelText, beneficiaryEditForm.value.clsr_addr2]
                        ])
                      ]),
                      (selectedBeneficiary.value.clsr_wdate || selectedBeneficiary.value.clsr_rdate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_229, "수집 정보"))
                        : _createCommentVNode("", true),
                      (selectedBeneficiary.value.clsr_wdate || selectedBeneficiary.value.clsr_rdate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                            _cache[193] || (_cache[193] = _createElementVNode("label", null, "수집일시", -1)),
                            _createElementVNode("input", {
                              value: formatDateTime(selectedBeneficiary.value.clsr_wdate || selectedBeneficiary.value.clsr_rdate),
                              type: "text",
                              readonly: ""
                            }, null, 8, _hoisted_231)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _createElementVNode("footer", _hoisted_232, [
                (selectedBeneficiary.value.clsr_source === 'manual')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "flat",
                      class: "btn-delete",
                      loading: beneficiaryDeleting.value,
                      onClick: deleteBeneficiary
                    }, {
                      default: _withCtx(() => [...(_cache[197] || (_cache[197] = [
                        _createTextVNode("삭제", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-confirm",
                  disabled: !canOpenBeneficiarySchedule(selectedBeneficiary.value),
                  onClick: openBeneficiaryScheduleFromDetail
                }, {
                  default: _withCtx(() => [...(_cache[198] || (_cache[198] = [
                    _createTextVNode("월간 일정", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: closeBeneficiaryDetail
                }, {
                  default: _withCtx(() => [...(_cache[199] || (_cache[199] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                }),
                (beneficiaryDetailTab.value === 'info')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "flat",
                      class: "btn-save",
                      loading: beneficiarySaving.value,
                      onClick: saveBeneficiaryEdit
                    }, {
                      default: _withCtx(() => [...(_cache[200] || (_cache[200] = [
                        _createTextVNode("저장", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: beneficiaryExcelModal.value,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((beneficiaryExcelModal).value = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_233, [
          _createElementVNode("header", _hoisted_234, [
            _cache[202] || (_cache[202] = _createElementVNode("div", null, [
              _createElementVNode("h3", null, "수급자 엑셀 업로드"),
              _createElementVNode("p", null, "인사관리와 회계(통장·수납) 수급자에 함께 반영됩니다.")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "hr-ben-excel-close",
              onClick: closeBeneficiaryExcelModal
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[201] || (_cache[201] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_235, [
            _createElementVNode("button", {
              type: "button",
              class: "hr-ben-excel-template",
              disabled: beneficiaryExcelUploading.value,
              onClick: downloadBeneficiaryTemplate
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[203] || (_cache[203] = [
                  _createTextVNode("mdi-download", -1)
                ]))]),
                _: 1
              }),
              _cache[204] || (_cache[204] = _createTextVNode(" 양식 다운로드 ", -1))
            ], 8, _hoisted_236),
            _createElementVNode("label", _hoisted_237, [
              _createElementVNode("input", {
                ref_key: "beneficiaryExcelInputRef",
                ref: beneficiaryExcelInputRef,
                type: "file",
                accept: ".xlsx,.xls",
                hidden: "",
                onChange: onBeneficiaryExcelSelected
              }, null, 544),
              _createVNode(_component_v_icon, {
                size: "28",
                color: "#1e7d47"
              }, {
                default: _withCtx(() => [...(_cache[205] || (_cache[205] = [
                  _createTextVNode("mdi-file-excel", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(beneficiaryExcelFileName.value || '엑셀 파일 선택 (.xlsx)'), 1)
            ]),
            (beneficiaryExcelMessage.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["hr-ben-excel-msg", { error: beneficiaryExcelError.value }])
                }, _toDisplayString(beneficiaryExcelMessage.value), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("footer", _hoisted_238, [
            _createElementVNode("button", {
              type: "button",
              class: "hr-ben-excel-cancel",
              disabled: beneficiaryExcelUploading.value,
              onClick: closeBeneficiaryExcelModal
            }, "취소", 8, _hoisted_239),
            _createElementVNode("button", {
              type: "button",
              class: "hr-ben-excel-upload",
              disabled: !beneficiaryExcelFile.value || beneficiaryExcelUploading.value,
              onClick: uploadBeneficiaryExcel
            }, _toDisplayString(beneficiaryExcelUploading.value ? '업로드 중…' : '업로드'), 9, _hoisted_240)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DaumPostcodeDialog, {
      modelValue: postcodeDialog.value,
      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((postcodeDialog).value = $event)),
      onSelect: onPostcodeSelect
    }, null, 8, ["modelValue"])
  ]))
}
}

})